{
  "common": {
    "main": {
      "project": "Проект",
      "form": "Форма",
      "version": "Версія",
      "formSettings": "Налаштування форми",
      "user": "Користувач",
      "organization": "Організація",
      "server": "Сервер",
      "url": "URL"
    },
    "buttons": {
      "ok": "ОК",
      "cancel": "Скасувати",
      "save": "Зберегти",
      "add": "Додати",
      "edit": "Редагувати",
      "delete": "Видалити",
      "refresh": "Оновити",
      "create": "Створити",
      "submit": "Відправити",
      "clear": "Очистити",
      "selectAll": "Вибрати все",
      "back": "Назад",
      "next": "Далі",
      "previous": "Попередній",
      "close": "Закрити",
      "confirm": "Підтвердити",
      "yes": "Так",
      "no": "Ні",
      "search": "Пошук",
      "filter": "Фільтр",
      "export": "Експорт",
      "import": "Імпорт",
      "download": "Завантажити",
      "upload": "Завантажити",
      "view": "Переглянути",
      "preview": "Попередній перегляд",
      "copy": "Копіювати",
      "assign": "Призначити",
      "unassign": "Відв'язати",
      "retry": "Повторити",
      "loading": "Завантаження..."
    },
    "dialogs": {
      "cancel": "Скасувати",
      "close": "Закрити",
      "confirm": "Підтвердити",
      "delete": "Видалити",
      "save": "Зберегти зміни",
      "confirmTitle": "Підтвердьте дію",
      "unsavedChanges": {
        "title": "Незбережені зміни",
        "message": "Є незбережені зміни. Закрити без збереження?"
      }
    },
    "table": {
      "headers": {
        "name": "Назва",
        "description": "Опис",
        "statistics": "Статистика",
        "status": "Статус",
        "actions": "Дії",
        "createdAt": "Дата створення",
        "updatedAt": "Дата оновлення",
        "created": "Створено",
        "updated": "Оновлено",
        "type": "Тип",
        "version": "Версія",
        "id": "ID",
        "email": "Email",
        "role": "Роль",
        "user": "Користувач",
        "project": "Проект",
        "organization": "Організація",
        "lastSubmission": "Останнє відправлення",
        "server": "Сервер",
        "url": "URL",
        "format": "Формат",
        "count": "Кількість",
        "size": "Розмір",
        "date": "Дата",
        "time": "Час",
        "severity": "Серйозність",
        "field": "Основне поле",
        "form": "Форма",
        "state": "Стан",
        "roles": "Ролі",
        "groups": "Групи",
        "formId": "ID форми",
        "permissions": "Дозволи",
        "enabled": "Увімкнено",
        "disabled": "Вимкнено",
        "submissions": "Відправлення",
        "publishedAt": "Опубліковано"
      },
      "pagination": {
        "page": "Сторінка",
        "of": "з",
        "perPage": "на сторінці",
        "showing": "Показано",
        "to": "до",
        "totalEntries": "загальна кількість записів",
        "resultsText": "результатів.",
        "perPageText": "Результатів на сторінці"
      },
      "ariaLabels": {
        "viewDetails": "Переглянути деталі",
        "edit": "Редагувати",
        "delete": "Видалити",
        "previousPage": "Попередня сторінка",
        "nextPage": "Наступна сторінка"
      }
    },
    "status": {
      "active": "Активний",
      "inactive": "Неактивний",
      "archived": "Архівований",
      "draft": "Чернетка",
      "published": "Опублікований",
      "pending": "Очікує",
      "completed": "Завершено",
      "failed": "Помилка",
      "success": "Успішно",
      "error": "Помилка",
      "warning": "Попередження",
      "info": "Інформація",
      "loading": "Завантаження",
      "notSet": "Не встановлено",
      "notSpecified": "Не вказано",
      "notAvailable": "Н/Д",
      "unknown": "Невідомо",
      "enabled": "Увімкнено",
      "disabled": "Вимкнено"
    },
    "messages": {
      "confirmDelete": "Ви впевнені, що хочете видалити",
      "confirmDeleteWithName": "Ви впевнені, що хочете видалити \"{name}\"?",
      "deleteSuccess": "Видалено успішно",
      "deleteError": "Помилка при видаленні",
      "saveSuccess": "Збережено успішно",
      "saveError": "Помилка при збереженні",
      "createSuccess": "Створено успішно",
      "createError": "Помилка при створенні",
      "updateSuccess": "Оновлено успішно",
      "updateError": "Помилка при оновленні",
      "error": "Сталася помилка",
      "loadError": "Помилка при завантаженні",
      "noData": "Немає даних",
      "noResults": "Немає результатів",
      "required": "Це поле обов'язкове",
      "invalidEmail": "Будь ласка, введіть правильну електронну адресу",
      "confirmDeleteWithType": "Ви впевнені, що хочете видалити \"{name}\" ({type})?",
      "bulkOperationSuccess": "Масову операцію виконано успішно",
      "bulkOperationError": "Помилка при виконанні масової операції",
      "operationFailed": "Не вдалося виконати операцію",
      "unsavedChanges": "Форма містить незбережені зміни. Ви впевнені, що хочете закрити її?",
      "created": "створено",
      "updated": "оновлено",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "Статистика",
      "subtitle": "Перегляньте статистику на рівні організації, стан форм та активність проектів.",
      "overall": "Загальна статистика",
      "byState": "Форми за станами",
      "projectDetails": "Деталі по проектах",
      "projectLedger": "Реєстр проектів",
      "pipeline": "Стан",
      "projectCount": "{count} проектів",
      "noActiveForms": "Немає активних форм",
      "projects": "Проектів",
      "totalForms": "Всього форм",
      "activeForms": "Активних форм",
      "submissions": "Відправок",
      "forms": "Форм",
      "lastUpdated": "Оновлено",
      "noDataToDisplay": "Немає даних для відображення"
    },
    "viewMode": {
      "cards": "Картки",
      "table": "Таблиця",
      "list": "Список",
      "grid": "Сітка"
    },
    "time": {
      "today": "сьогодні",
      "yesterday": "вчора",
      "thisWeek": "цього тижня",
      "lastWeek": "минулого тижня",
      "thisMonth": "цього місяця",
      "lastMonth": "минулого місяця",
      "allTime": "за весь час",
      "last7Days": "Останні 7 днів",
      "last30Days": "Останні 30 днів",
      "last90Days": "Останні 90 днів",
      "customRange": "Довільний діапазон",
      "startDate": "Дата початку",
      "endDate": "Дата закінчення",
      "justNow": "Тільки що",
      "minutesAgo": "{count} хв тому",
      "hoursAgo": "{count} год тому",
      "daysAgo": "{count} дн тому",
      "never": "Ніколи"
    },
    "placeholders": {
      "enterName": "Введіть назву",
      "enterDescription": "Введіть опис",
      "enterEmail": "Введіть email",
      "enterUrl": "Введіть URL",
      "search": "Пошук...",
      "selectOption": "Виберіть варіант"
    },
    "formState": {
      "title": "Зміна статусу форми",
      "form": "Форма",
      "currentStatus": "Поточний статус",
      "newStatus": "Новий статус",
      "pleaseSelectStatus": "Будь ласка, виберіть статус",
      "statusChangedSuccessfully": "Статус форми {formName} успішно змінено на {status}",
      "errorChangingStatus": "Помилка зміни статусу форми"
    }
  },
  "admin": {
    "agent": {
      "title": "Агент Hermes",
      "subtitle": "Моніторуйте і керуйте інтеграцією AI-агента",
      "back": "Назад до панелі",
      "health": {
        "title": "Здоров'я інтеграції",
        "checkNow": "Перевірити зараз",
        "latency": "Затримка",
        "lastCheck": "Остання перевірка"
      },
      "stats": {
        "activeSubs": "Активні підписки",
        "requestsToday": "Запитів сьогодні",
        "tokensToday": "Токенів сьогодні",
        "nearQuota": "Організацій біля квоти",
        "activeSubsHint": "всього {total}",
        "nearQuotaHint": ">80% використано"
      },
      "config": {
        "title": "Конфігурація (тільки для читання)"
      },
      "jobs": {
        "title": "RQ Jobs (аналітичні звіти)",
        "empty": "Немає недавніх jobs"
      },
      "digests": {
        "title": "Проактивні дайджести",
        "trigger": "Запустити вручну",
        "historyTitle": "Історія дайджестів",
        "historyEmpty": "Дайджести ще не запускалися."
      },
      "selfHeal": {
        "title": "Самолікування задач",
        "trigger": "Запустити зараз"
      },
      "incident": {
        "banner": "Hermes або MCP інтеграція не здорова. Функції агента можуть бути погіршені.",
        "title": "Потребує уваги"
      },
      "subscriptions": {
        "title": "Агенти підписки",
        "subtitle": "Керуйте рівнями, квотами і функціями по організаціях",
        "searchPlaceholder": "Пошук організації...",
        "allTiers": "Усі рівні",
        "editTitle": "Редагувати підписку",
        "resetTitle": "Скинути використання",
        "resetMessage": "Скинути лічильники використання для {name}?",
        "resetConfirm": "Скинути",
        "empty": "Підписки не знайдено",
        "tierDefaultsTitle": "Типові значення рівнів",
        "tierDefaultsHint": "Довідкові ліміти з backend SSOT. Зміна рівня у формі редагування застосовує ці значення (перевизначення можливі).",
        "columns": {
          "org": "Організація",
          "tier": "Рівень",
          "fiveHour": "5 год",
          "week": "Тиждень",
          "month": "Місяць",
          "features": "Функції"
        },
        "tierDefaults": {
          "fiveHour": "5 год (зап. / ток.)",
          "week": "Тиждень (зап. / ток.)",
          "month": "Місяць (зап. / ток.)"
        }
      },
      "usage": {
        "title": "Використання агента",
        "subtitle": "Журнал викликів по організаціях",
        "orgIdPlaceholder": "ID організації",
        "allFeatures": "Усі функції",
        "empty": "Немає подій використання",
        "columns": {
          "time": "Час",
          "org": "Організація",
          "user": "Користувач",
          "feature": "Функція",
          "tokens": "Токени"
        }
      },
      "audit": {
        "title": "Аудит tool-calls",
        "subtitle": "Журнал викликів MCP-інструментів (особливо write-actions)",
        "orgIdPlaceholder": "ID організації",
        "toolPlaceholder": "Назва інструмента",
        "writeOnly": "Тільки write-інструменти",
        "detailTitle": "Деталі аудиту",
        "detail": "Деталі",
        "empty": "Немає записів аудиту",
        "write": "Запис",
        "read": "Читання",
        "columns": {
          "time": "Час",
          "org": "Організація",
          "tool": "Інструмент",
          "write": "Запис"
        }
      },
      "sections": {
        "metrics": "Пульс"
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Видалити проєкт",
        "message": "Цю дію не можна скасувати. Усі пов'язані форми будуть видалені.",
        "formsCount": "Форм до видалення: {count}",
        "confirm": "Видалити назавжди"
      },
      "deleteOrganization": {
        "title": "Видалити організацію",
        "message": "Цю дію не можна скасувати. Усі проєкти та користувачі будуть зачеплені.",
        "confirm": "Видалити назавжди"
      },
      "deleteForm": {
        "title": "Видалити форму",
        "message": "Цю дію не можна скасувати.",
        "confirm": "Видалити назавжди"
      },
      "deleteUser": {
        "title": "Видалити користувача",
        "message": "Цю дію не можна скасувати. Користувач втратить доступ до всіх організацій.",
        "confirm": "Видалити назавжди"
      },
      "projectDetails": "Проєкт: {name}",
      "organizationDetails": "Організація: {name}",
      "formDetails": "Форма: {name}",
      "userDetails": "Користувач: {name}",
      "close": "Закрити",
      "createUser": {
        "title": "Створити користувача"
      },
      "editUser": {
        "title": "Редагувати користувача"
      },
      "fullName": "Ім'я та прізвище",
      "superuser": "Суперкористувач",
      "active": "Активний"
    },
    "back": "Назад до панелі",
    "chrome": {
      "sessionLabel": "Суперкористувач · усі дії логуються",
      "exit": "Вийти з режиму",
      "menuTitle": "Адміністрування",
      "sessionWarning": "Адміністративна сесія завершиться через {time}.",
      "extendSession": "Продовжити сесію"
    },
    "nav": {
      "groups": {
        "overview": "Огляд",
        "directory": "Каталог",
        "access": "Доступ",
        "integrations": "Інтеграції",
        "platform": "Платформа"
      },
      "dashboard": "Панель керування",
      "analytics": "Аналітика",
      "users": "Користувачі",
      "organizations": "Організації",
      "projects": "Проекти",
      "forms": "Форми",
      "roles": "Ролі та дозволи",
      "permissionGroups": "Групи дозволів",
      "agent": "Hermes Agent",
      "agentDashboard": "Панель агента",
      "agentSubscriptions": "Підписки агента",
      "agentUsage": "Використання агента",
      "agentAudit": "Аудит агента",
      "globalOdk": "Глобальні ODK сервери",
      "system": "Система",
      "audit": "Аудит",
      "subscriptions": "Білінг"
    },
    "pagination": {
      "shown": "Показано {start} - {end} з {total}",
      "pageOf": "Сторінка {page} з {pages}",
      "previous": "Попередня",
      "next": "Наступна"
    },
    "common": {
      "tryAgain": "Спробувати знову",
      "showDeleted": "Показати видалені",
      "hideDeleted": "Приховати видалені",
      "showArchived": "Показати архівні",
      "hideArchived": "Приховати архівні",
      "allOrganizations": "Усі організації",
      "allProjects": "Усі проекти",
      "allRoles": "Усі ролі",
      "allStatuses": "Усі статуси",
      "totalRecords": "Всього записів: {count}",
      "orgIdPrefix": "Орг. #{id}",
      "projectIdPrefix": "Проект #{id}",
      "notSet": "Не встановлено",
      "health": {
        "healthy": "Працює",
        "degraded": "Деградація",
        "disabled": "Вимкнено",
        "unhealthy": "Помилка",
        "unknown": "Невідомо"
      }
    },
    "pages": {
      "users": {
        "title": "Керування користувачами",
        "subtitle": "Перегляд і керування всіма користувачами системи",
        "addUser": "Додати користувача",
        "searchPlaceholder": "Пошук користувачів...",
        "superuserBadge": "Суперкористувач",
        "userBadge": "Користувач",
        "statsTotal": "Всього",
        "statsSuperusers": "Суперкористувачі",
        "statsOwners": "Власники",
        "statsActive": "Активні",
        "loadError": "Не вдалося завантажити користувачів",
        "empty": "Немає користувачів за поточними фільтрами"
      },
      "organizations": {
        "title": "Керування організаціями",
        "subtitle": "Перегляд і керування всіма організаціями системи",
        "searchPlaceholder": "Пошук за назвою або описом організації...",
        "sectionTitle": "Організації",
        "loading": "Завантаження організацій...",
        "empty": "Організації не знайдено",
        "loadError": "Не вдалося завантажити організації",
        "restored": "Організацію відновлено",
        "restoreError": "Не вдалося відновити організацію",
        "owner": "Власник",
        "created": "Створено",
        "deletedBadge": "Видалена",
        "activeBadge": "Активна",
        "agentSubscription": "Підписка агента",
        "statsTotal": "Всього організацій",
        "statsActive": "Активних",
        "statsProjects": "Проектів",
        "statsForms": "Форм"
      },
      "projects": {
        "title": "Керування проектами",
        "subtitle": "Перегляд і керування всіма проектами системи",
        "searchPlaceholder": "Пошук за назвою або описом проекту...",
        "sectionTitle": "Проекти",
        "loading": "Завантаження проектів...",
        "empty": "Проекти не знайдено",
        "loadError": "Не вдалося завантажити проекти",
        "archived": "Проект архівовано",
        "unarchived": "Проект розархівовано",
        "archiveError": "Не вдалося архівувати проект",
        "unarchiveError": "Не вдалося розархівувати проект",
        "created": "Створено",
        "archivedBadge": "Архівний",
        "activeBadge": "Активний",
        "statsTotal": "Всього проектів",
        "statsActive": "Активних",
        "statsArchived": "Архівних",
        "statsForms": "Форм"
      },
      "forms": {
        "title": "Керування формами",
        "subtitle": "Перегляд і керування всіма формами системи",
        "searchPlaceholder": "Пошук за назвою форми або XML ID...",
        "sectionTitle": "Форми",
        "loading": "Завантаження форм...",
        "empty": "Форми не знайдено",
        "loadError": "Не вдалося завантажити форми",
        "deletedToast": "Форму позначено як видалену",
        "restoredToast": "Форму відновлено",
        "deleteError": "Не вдалося видалити форму",
        "restoreError": "Не вдалося відновити форму",
        "created": "Створено",
        "deletedBadge": "Видалена",
        "activeBadge": "Активна",
        "importedBadge": "Імпортована",
        "statsTotal": "Всього форм",
        "statsActive": "Активних",
        "statsDeleted": "Видалених",
        "statsImported": "Імпортованих"
      },
      "permissionGroups": {
        "title": "Групи дозволів",
        "subtitle": "Керуйте групами дозволів і призначайте їх користувачам",
        "createGroup": "Створити групу",
        "sectionTitle": "Групи дозволів",
        "searchPlaceholder": "Пошук груп...",
        "emptyFilter": "Немає груп за поточним пошуком",
        "restoreError": "Не вдалося відновити групу дозволів",
        "deleteError": "Не вдалося видалити групу дозволів",
        "emptyTitle": "Групи дозволів не знайдено",
        "emptyBody": "Створіть першу групу дозволів, щоб почати",
        "deleteTitle": "Видалити групу",
        "deleteMessage": "Ви впевнені, що хочете видалити групу \"{name}\"? Цю дію не можна скасувати.",
        "restoreTitle": "Відновити",
        "users": "Користувачі",
        "statsTotal": "Всього груп",
        "statsActive": "Активні групи",
        "statsAssignments": "Призначень",
        "loadError": "Не вдалося завантажити групи дозволів",
        "restored": "Групу \"{name}\" відновлено",
        "deleted": "Групу дозволів видалено",
        "saved": "Групу дозволів збережено",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Глобальні ODK сервери",
        "subtitle": "Створення та керування загальносистемними ODK серверами",
        "createServer": "Створити сервер",
        "statsTotal": "Всього серверів",
        "statsTotalHint": "{count} (+{active} активних)",
        "statsGlobal": "Глобальних",
        "statsDefault": "За замовчуванням",
        "testTitle": "Результат тесту підключення",
        "testOk": "Підключення успішне",
        "testFail": "Помилка підключення",
        "testMethod": "Метод:",
        "testProjects": "Кількість проектів:",
        "testing": "Тестування підключення...",
        "refreshTokenTitle": "Оновити API токен",
        "refreshTokenBody": "Введіть пароль для оновлення API токена сервера",
        "password": "Пароль",
        "passwordPlaceholder": "Введіть пароль",
        "refreshTokenAction": "Оновити токен",
        "requiredField": "Це поле обов'язкове",
        "searchPlaceholder": "Пошук за назвою, URL або користувачем...",
        "empty": "Немає глобальних ODK серверів",
        "emptyHint": "Створіть перший глобальний ODK сервер, щоб почати.",
        "emptyFilter": "Немає серверів за поточним пошуком",
        "defaultBadge": "За замовчуванням",
        "columns": {
          "server": "Сервер",
          "user": "Користувач",
          "visibility": "Видимість"
        },
        "visibility": {
          "GLOBAL": "Глобальний",
          "ORGANIZATION": "Організація",
          "SHARED": "Спільний"
        },
        "actions": {
          "test": "Тестувати підключення",
          "refreshToken": "Оновити токен",
          "setDefault": "Встановити за замовчуванням"
        },
        "deleteTitle": "Видалити сервер",
        "deleteMessage": "Видалити сервер \"{name}\"? Цю дію не можна скасувати.",
        "setDefaultTitle": "Встановити сервер за замовчуванням",
        "setDefaultMessage": "Встановити \"{name}\" як глобальний сервер ODK за замовчуванням?",
        "setDefaultConfirm": "Встановити",
        "toastCreated": "Сервер створено",
        "toastUpdated": "Сервер оновлено",
        "toastDeleted": "Сервер видалено",
        "toastTestOk": "Підключення успішне",
        "toastTokenRefreshed": "API токен оновлено",
        "toastDefaultSet": "Глобальний сервер за замовчуванням оновлено",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Білінг-підписки",
        "subtitle": "SaaS-білінг і платіжні плани (не квоти Hermes Agent)",
        "billingNotice": "Білінг і платіжні підписки в розробці. Нижче — актуальні дані підписок і використання Hermes Agent.",
        "partialLoadError": "Не вдалося завантажити частину даних.",
        "agentSubs": "Підписки агента",
        "activeCount": "{count} активних",
        "requestsToday": "Запитів сьогодні",
        "agentStatus": "Статус агента",
        "sectionTitle": "Підписки Hermes Agent",
        "sectionSubtitle": "Організації з доступом до інтеграції агента",
        "manageCta": "Керувати підписками",
        "empty": "Підписки не знайдено",
        "tier": "Рівень",
        "usage": "Використання",
        "resourcesTitle": "Використання ресурсів системи",
        "orgs": "Організації",
        "projects": "Проекти",
        "forms": "Форми",
        "submissions": "Відправлення",
        "stubBadge": "Скоро",
        "stubBody": "Білінг і платіжні підписки в розробці. Ця сторінка керуватиме комерційними планами, коли білінг буде готовий.",
        "stubAgentHint": "Рівні, квоти та функції Hermes Agent керуються в Інтеграції → Hermes Agent → Підписки.",
        "openAgentSubscriptions": "Відкрити підписки агента"
      },
      "audit": {
        "title": "Аудит дій",
        "subtitle": "Журнал адміністративних дій суперкористувачів",
        "loadError": "Не вдалося завантажити журнал аудиту.",
        "empty": "Записів аудиту поки немає",
        "time": "Час",
        "user": "Користувач",
        "action": "Дія",
        "details": "Деталі",
        "emptyFilter": "Немає записів за поточним пошуком",
        "searchPlaceholder": "Пошук за користувачем, дією або деталями...",
        "actionKey": "Ключ дії",
        "detailTitle": "Запис аудиту"
      },
      "system": {
        "title": "Стан системи",
        "subtitle": "Діагностика інфраструктури — статус, затримки та runtime-деталі",
        "loadError": "Не вдалося завантажити стан системи.",
        "serverInfo": "Runtime-деталі",
        "version": "Версія",
        "uptime": "Аптайм процесу",
        "dbConnections": "З'єднання БД (активні)",
        "dbPool": "Розмір пулу БД",
        "components": {
          "server": "Сервер",
          "database": "База даних",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        },
        "attentionTitle": "Потребує уваги",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Відкрити агента",
        "componentsTitle": "Компоненти",
        "dbLatency": "Затримка БД",
        "apiLatency": "Затримка API"
      },
      "analytics": {
        "title": "Аналітична панель",
        "subtitle": "Аналітика системи та користувачів",
        "loadError": "Не вдалося завантажити аналітику. Показано нульові значення.",
        "totalUsers": "Всього користувачів",
        "thisMonth": "+{count} цього місяця",
        "organizations": "Організацій",
        "growthPct": "{pct}% зростання",
        "totalProjects": "Всього проектів",
        "totalForms": "Всього форм",
        "submissions": "Відправлень",
        "userGrowth": "Зростання користувачів (за місяцями)",
        "orgActivity": "Активність організацій (за проектами)",
        "noData": "Немає даних",
        "topOrgs": "Топ організацій",
        "projectsCount": "{count} проектів",
        "noOrgs": "Немає організацій",
        "recentActivity": "Остання активність",
        "noRecent": "Немає недавніх дій",
        "systemHealth": "Стан системи",
        "resources": "Використання ресурсів",
        "orgs": "Організацій",
        "projects": "Проектів",
        "forms": "Форм",
        "health": {
          "api": "API",
          "database": "База даних",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Ролі та дозволи",
        "subtitle": "Каталог платформних ролей — будівельні блоки для груп дозволів",
        "searchPlaceholder": "Пошук ролей...",
        "loadError": "Не вдалося завантажити ролі.",
        "emptyTitle": "Ролі не знайдено",
        "emptyFilter": "Немає ролей за поточним пошуком",
        "openGroups": "Групи дозволів",
        "system": "Системна",
        "custom": "Користувацька",
        "unused": "Не використовується в жодній групі",
        "columns": {
          "role": "Роль",
          "description": "Опис",
          "usedIn": "У групах",
          "type": "Тип"
        },
        "labels": {
          "project_member": "Учасник проєкту"
        },
        "descriptions": {
          "fallback": "Опис недоступний.",
          "manager": "Повне керування проєктом і нагляд за якістю.",
          "project_member": "Мінімальний доступ до проєкту — назва та форми, без даних подань.",
          "data_viewer": "Лише читання подань, моніторинг і перегляд QC.",
          "data_collector": "Збір і надсилання польових даних.",
          "data_downloader": "Експорт і завантаження даних подань.",
          "data_analyst": "Операції QC та аналіз даних.",
          "form_designer": "Створення й керування XLSForm.",
          "qc_editor": "Редагування результатів і знахідок QC."
        }
      }
    },
    "dashboard": {
      "title": "Огляд",
      "subtitle": "Стан платформи та недавні дії адміністраторів",
      "errors": {
        "stats": "Не вдалося завантажити системні метрики. Показано нулі.",
        "health": "Не вдалося завантажити стан системи.",
        "activities": "Не вдалося завантажити останні дії."
      },
      "attention": {
        "title": "Потребує уваги",
        "server": "Сервер повідомляє про проблеми.",
        "database": "База даних повідомляє про проблеми.",
        "redis": "Redis повідомляє про проблеми.",
        "api": "API повідомляє про проблеми.",
        "agent": "Статус Hermes Agent: {status}.",
        "failedLogins": "{count} невдалих спроб входу за останні 24 години.",
        "openSystem": "Відкрити систему",
        "openAgent": "Відкрити агента",
        "openAudit": "Відкрити аудит"
      },
      "sections": {
        "metrics": "Каталог",
        "health": "Здоров'я",
        "activity": "Останні дії"
      },
      "metrics": {
        "users": "Користувачі",
        "usersHint": "+{count} сьогодні",
        "orgs": "Організації",
        "orgsHint": "+{count} за тиждень",
        "projects": "Проекти",
        "projectsHint": "{count} активних",
        "failedLogins": "Невдалі входи",
        "failedLoginsHint": "За останні 24 години"
      },
      "health": {
        "server": "Сервер",
        "database": "База даних",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "{count} з'єднань",
        "latency": "{ms} мс",
        "agentHint": "{count} зап. сьогодні"
      },
      "activity": {
        "viewAll": "Весь аудит",
        "empty": "Немає недавніх дій адміністраторів"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Завантаження підписки агента...",
      "working": "Агент працює..."
    },
    "features": {
      "reports": "Звіти",
      "qc": "QC асистент",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "errors": {
      "generic": "Не вдалося викликати агента.",
      "endpointNotFound": "Ця функція агента не доступна на запущеному backend. Перезапустіть backend dev server (.\\scripts\\dev.ps1).",
      "timeout": "Агент не відповів вчасно. XLSForm асистент може зайняти до 10 хвилин — спробуйте знову.",
      "featureUnavailable": "Ця функція не доступна на вашому плані.",
      "quotaExceeded": "Квота агента перевищена для цього періоду.",
      "disabled": "AI агент тимчасово вимкнений.",
      "mcpUnavailable": "Hermes не може бачити udacapi MCP інструменти. Зареєструйте MCP на CT253 (grant-udacapi-mcp.sh) і перевірте relay :8101 → backend :8100. Дивіться runbooks/hermes-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Вичерпано місячний ліміт запитів",
          "tokens": "Вичерпано місячний ліміт токенів"
        },
        "five_hour": {
          "requests": "Вичерпано ліміт запитів за 5 годин",
          "tokens": "Вичерпано ліміт токенів за 5 годин"
        },
        "weekly": {
          "requests": "Вичерпано тижневий ліміт запитів",
          "tokens": "Вичерпано тижневий ліміт токенів"
        }
      },
      "usageLine": "Використано {used} з {limit}",
      "resetsAt": "Знову доступно {relative} ({absolute})",
      "resetsUnknown": "Спробуйте пізніше або зверніться до адміністратора для збільшення ліміту.",
      "viewSubscription": "Детальніше про квоти",
      "sendBlocked": "Квоту агента вичерпано — дочекайтеся скидання ліміту.",
      "nearLimit": "Квоту агента майже вичерпано ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Функція заблокована",
      "lockedDescription": "\"{feature}\" доступна на плані {tier} і вище."
    },
    "subscription": {
      "sectionTitle": "AI агент",
      "sectionDescription": "Рівень агента вашої організації, квоти і доступні функції.",
      "currentTier": "Поточний рівень",
      "active": "Активний",
      "inactive": "Неактивний",
      "features": "Доступні функції",
      "tier": "Рівень",
      "capabilities": "Можливості",
      "billingPeriod": "Початок розрахункового періоду",
      "requests": "Запити за цей період",
      "requests_5h": "Запити (останні 5 годин)",
      "requests_weekly": "Запити (останній тиждень)",
      "requests_badge": "зап.",
      "requests_5h_badge": "зап. (5г)",
      "requests_weekly_badge": "зап. (тиж.)",
      "tokens": "Токенів за цей період",
      "tokens_5h": "Токенів (останні 5 годин)",
      "tokens_weekly": "Токенів (останній тиждень)",
      "nearQuotaTitle": "Близькі квоти",
      "nearQuotaDescription": "Більше 80% місячної квоти використовується. Зверніться до адміністратора для збільшення квот.",
      "tiers": {
        "free": "Безкоштовно",
        "pro": "Pro",
        "enterprise": "Корпоративний"
      },
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked."
    },
    "report": {
      "title": "AI звіт для PM",
      "description": "Сумаризована відповідь підготовлена AI-агентом UDA.",
      "period": "Період (днів)",
      "generate": "Згенерувати звіт",
      "generating": "Агент готує звіт...",
      "empty": "Натисніть \"Згенерувати звіт\" для отримання сумарної інформації.",
      "modeSummary": "Сумаризована",
      "modeAnalytical": "Аналітична",
      "quotaExceeded": "Квота агента перевищена для цього періоду.",
      "featureUnavailable": "AI звіти не доступні на вашому плані.",
      "error": "Не вдалося отримати звіт від агента.",
      "healthAlerts": "Записи про здоров'я форми",
      "copy": "Скопіювати звіт",
      "copied": "Скопійовано",
      "copyFailed": "Не вдалося скопіювати в буфер обміну.",
      "viewFormatted": "Форматований",
      "viewRaw": "Markdown",
      "templates": {
        "title": "Шаблони звітів",
        "subtitle": "Налаштуйте розклад і промпти AI-звітів для цієї організації.",
        "create": "Новий шаблон",
        "createTitle": "Створити шаблон звіту",
        "edit": "Редагувати",
        "editTitle": "Редагувати шаблон звіту",
        "formSubtitle": "Визначте зміст звіту, розклад запуску та отримувачів.",
        "sections": {
          "content": "Зміст звіту",
          "schedule": "Розклад",
          "delivery": "Доставка та охоплення"
        },
        "seed": "Завантажити типові",
        "seeded": "Додано шаблонів: {count}.",
        "empty": "Шаблонів поки немає. Завантажте типові або створіть новий.",
        "active": "Активний",
        "inactive": "Неактивний",
        "cron": "Розклад",
        "sendByEmail": "Надсилати на email",
        "deactivate": "Деактивувати",
        "deactivated": "Шаблон деактивовано.",
        "activate": "Активувати",
        "activated": "Шаблон активовано.",
        "save": "Зберегти",
        "saved": "Шаблон збережено.",
        "saveError": "Не вдалося зберегти шаблон.",
        "loadError": "Не вдалося завантажити шаблони звітів.",
        "validationRequired": "Потрібні назва та промпт.",
        "recipientsPlaceholder": "Виберіть учасників організації",
        "recipientsRequired": "Виберіть принаймні одного одержувача, якщо увімкнено email.",
        "promptHint": "Доступ до даних організації, вибраних форм і звітного періоду додається автоматично.",
        "allFormsPlaceholder": "Усі форми (залиште порожнім)",
        "advancedMode": "Власний промпт (розширений, Jinja2)",
        "fields": {
          "name": "Назва",
          "audience": "Аудиторія",
          "prompt": "Інструкції для звіту",
          "responseLanguage": "Мова відповіді",
          "recipients": "Одержувачі",
          "formScope": "Форми"
        },
        "schedule": {
          "label": "Розклад",
          "none": "Без розкладу",
          "daily": "Щодня",
          "weekly": "Щотижня",
          "monthly": "Щомісяця",
          "custom": "Власний (cron)",
          "time": "Час",
          "weekday": "День тижня",
          "dayOfMonth": "День місяця",
          "customCron": "Cron-вираз",
          "humanDaily": "Щодня о {time}",
          "humanWeekly": "Кожен(а) {weekday} о {time}",
          "humanMonthly": "Щомісяця {day}-го числа о {time}",
          "weekdays": {
            "0": "Неділя",
            "1": "Понеділок",
            "2": "Вівторок",
            "3": "Середа",
            "4": "Четвер",
            "5": "П'ятниця",
            "6": "Субота"
          }
        },
        "audience": {
          "pm": "Менеджер проекту",
          "field_coord": "Польовий координатор",
          "statistician": "Статистик",
          "executive": "Керівництво"
        }
      }
    },
    "chat": {
      "modeAsk": "Запитати агента",
      "description": "Запитайте питання про схему форми, відправлення, аналізи, правила QC і стан синхронізації. Відповіді базуються на живих даних; прикладові відправлення можуть містити персональні поля.",
      "question": "Ваше питання",
      "placeholder": "Напр.: Скільки відправлень за останні 7 днів? Які поля має ця форма?",
      "send": "Відправити",
      "empty": "Запитайте питання про дані цієї форми.",
      "you": "Ви",
      "agent": "Агент",
      "generating": "Агент шукає дані форми...",
      "sendHint": "Enter — відправити · Shift+Enter — нова строка"
    },
    "analytical": {
      "generate": "Запустити аналітичний звіт",
      "empty": "Запустіть аналітичний звіт для глибокого аналізу форми.",
      "queued": "Звіт у черзі...",
      "status": "Статус: {status}",
      "done": "Звіт готовий.",
      "failed": "Не вдалося згенерувати аналітичний звіт.",
      "emptyResult": "Звіт завершився, але не повернув вміст.",
      "timeout": "Аналітичний звіт зайняв занадто багато часу. Перевірте, чи працює служба agent-reports-worker.",
      "workerHint": "Задача все ще у черзі. Запустіть службу agent-reports-worker (docker compose up -d agent-reports-worker) і спробуйте знову."
    },
    "qc": {
      "title": "AI QC асистент",
      "description": "Опишіть перевірку простим мовою — агент створить правило QC.",
      "checkDescription": "Опис перевірки",
      "checkPlaceholder": "Напр.: вік респондента повинен бути від 18 до 65",
      "suggest": "Запропонувати правило",
      "generating": "Агент готує правило...",
      "applyDraft": "Застосувати чернетку до форми",
      "draftApplied": "Чернетку застосовано до правила форми.",
      "draftPreview": "Запропоноване правило",
      "viewRawResponse": "Переглянути повну відповідь агента",
      "sendHint": "Enter — запропонувати · Shift+Enter — нова строка",
      "noDraftParsed": "Не вдалося розпарсити JSON чернетки правила відповіді агента.",
      "validationWarnings": "Зауваження валідації ({count}):",
      "starterPack": {
        "title": "Початкові правила QC",
        "description": "Огляньте форму і отримайте запропоновані правила для початку валідації.",
        "focus": "Фокус",
        "focusAll": "Збалансований мікс",
        "focusRequired": "Тільки обов'язкові поля",
        "focusConstraints": "Тільки обмеження",
        "maxRules": "Максимальна кількість правил",
        "suggest": "Запропонувати початкові правила",
        "generating": "Огляд форми і створення правил...",
        "apply": "Застосувати це правило",
        "empty": "Немає валідних чернеток правил. Спробуйте знову або використовуйте запропоноване правило вище.",
        "skippedHint": "{count} запропонованих правил були пропущені (дублікат, невалідний, або перевищено ліміт)."
      }
    },
    "xlsform": {
      "openButton": "AI XLSForm",
      "title": "AI XLSForm асистент",
      "description": "Завантажте файл з питаннями або опишіть завдання — агент створить, протестує і запитає підтвердження публікації.",
      "instruction": "Інструкція для агента",
      "instructionPlaceholder": "Напр.: створити форму опитування задоволеності з 5 питань",
      "empty": "Опишіть, яку форму вам потрібно або завантажте файл — агент створить і протестує її.",
      "send": "Відправити",
      "sendHint": "Enter — відправити · Shift+Enter — нова строка",
      "working": "Агент працює над завданням...",
      "you": "Ви",
      "agent": "Агент",
      "publishTitle": "Підтвердження публікації",
      "publishDescription": "Агент запитав публікацію чернетки. Підтвердьте вручну — публікація не може продовжуватися без підтвердження.",
      "formId": "ID форми (xmlFormId)",
      "versionOptional": "Версія (опціонально)",
      "confirmPublish": "Підтвердити публікацію",
      "upload": {
        "hint": "Приклейте Excel/CSV, Word або текст з вашими питаннями (max 5 MB)",
        "attachAria": "Прикріпити файл",
        "removeAttachment": "Прибрати вкладення",
        "selected": "Файл: {name}",
        "attachmentPrefix": "[файл: {name}]"
      },
      "session": {
        "resumeBanner": "У вас є незавершена сесія AI XLSForm (чернетка: {formId})",
        "resumeButton": "Продовжити",
        "startNewButton": "Почати заново",
        "dismissButton": "Приховати",
        "dismissError": "Не вдалося закрити сесію. Спробуйте ще раз.",
        "historyButton": "Минулі сесії",
        "historyTitle": "Сесії AI XLSForm",
        "historyHint": "Сесії за останні 7 днів. Продовжте чернетку або перегляньте опубліковану сесію.",
        "historyEmpty": "Немає минулих сесій для цього проєкту.",
        "historyFormColumn": "Чернетка форми",
        "historyStatusColumn": "Статус",
        "historyUpdatedColumn": "Оновлено",
        "historyMessagesColumn": "Повідомлення",
        "historyActionsColumn": "Дії",
        "continueButton": "Продовжити",
        "viewButton": "Перегляд",
        "continueError": "Не вдалося відновити сесію. Спробуйте ще раз.",
        "readOnlyHint": "Сесію опубліковано. Можна переглянути історію чату, але не можна надсилати нові повідомлення.",
        "draftUnknown": "без імені",
        "status": {
          "active": "Активна",
          "discarded": "Прихована",
          "failed": "Помилка",
          "published": "Опублікована"
        }
      },
      "job": {
        "canClose": "Ви можете закрити це вікно — ваша сесія буде продовжуватися в тлі.",
        "elapsed": "Роботає… {time}",
        "agentWorking": "Агент обробляє ваш запит (LLM і MCP інструменти). Цей крок може зайняти кілька хвилин.",
        "longWait": "Все ще працює — перевірте, чи здорові LLM proxy і Hermes MCP relay, якщо це займає більше 10 хвилин.",
        "timeout": "Асистент форми не завершив роботу вчасно. Невдалу сесію скинуто; повторіть запит у новій сесії.",
        "failed": "Форма асистент не вдався. Спробуйте знову.",
        "phases": {
          "queued": "У черзі",
          "planning": "Аналізує ваш запит",
          "editing": "Редагує питання форми",
          "uploading_draft": "Створює чернетку форми",
          "testing_draft": "Тестування чернетки",
          "finalizing": "Підготовка відповіді",
          "completed": "Виконано"
        },
        "queuedFallback": "Роботник ще не взяв завдання — сервер скоро повторить його."
      },
      "preview": {
        "tabChat": "Чат",
        "tabPreview": "Попередній перегляд",
        "loading": "Завантаження попереднього перегляду форми…",
        "empty": "Немає чернетки для попереднього перегляду. Запитайте асистента створити або редагувати форму.",
        "error": "Не вдалося завантажити попередній перегляд форми.",
        "submitError": "Не вдалося відправити тестове відправлення."
      }
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Синхронізація завершена: {formName}. Оброблено {count} з {total} записів",
      "syncError": "Помилка синхронізації: {formName}. {error}",
      "formStatusChange": "Статус форми змінено: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Планувальник: {status}. Активних завдань: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "QC валідація завершена: {instanceId}. Правил: {totalRules}, пройшло: {passedRules}, помилок: {errorRules}, попереджень: {warningRules}",
      "projectStatusSummary": "Критичні зміни: {errorProjects} проектів з помилками, {errorForms} форм з помилками з {totalProjects} проектів та {totalForms} форм"
    },
    "connection": {
      "connected": "WebSocket підключений",
      "disconnected": "WebSocket відключений",
      "reconnecting": "Перепідключення...",
      "error": "Помилка WebSocket: {error}",
      "maxRetriesReached": "Досягнуто максимальну кількість спроб перепідключення"
    },
    "connected": "Підключений",
    "disconnected": "Відключений",
    "realTimeUpdates": "Оновлення в реальному часі"
  },
  "buttonSelect": {
    "dark": "Темна",
    "light": "Світла"
  },
  "odkOptions": {
    "themes": {
      "light": "Світла",
      "dark": "Темна"
    },
    "navigation": {
      "swipe": "Свайпи",
      "buttons": "Кнопки",
      "swipe_buttons": "Свайпи + Кнопки"
    },
    "formUpdate": {
      "manual": "Вручну",
      "previously_downloaded": "Раніше завантажені",
      "match_exactly": "Точна відповідність"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Кожні 15 хвилин",
      "every_one_hour": "Щогодини",
      "every_six_hours": "Кожні 6 годин",
      "every_24_hours": "Кожні 24 години"
    },
    "autosend": {
      "off": "Вимк.",
      "wifi_only": "Тільки Wi‑Fi",
      "cellular_only": "Тільки мобільна мережа",
      "wifi_and_cellular": "Wi‑Fi і мобільна мережа"
    },
    "constraintBehavior": {
      "on_swipe": "При свайпі",
      "on_finalize": "При фіналізації"
    },
    "imageSizes": {
      "original": "Оригінал",
      "very_small": "Дуже малий",
      "small": "Малий",
      "medium": "Середній",
      "large": "Великий"
    },
    "guidanceHint": {
      "no": "Ні",
      "yes": "Так",
      "yes_collapsed": "Так (згорнуто)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Звичайний",
      "terrain": "Рельєф",
      "hybrid": "Гібрид",
      "satellite": "Супутник",
      "light": "Світлий",
      "dark": "Темний",
      "satellite_streets": "Супутник + вулиці",
      "outdoors": "На природі",
      "topographic": "Топографічний",
      "positron": "Positron",
      "dark_matter": "Dark matter"
    },
    "fontSizes": {
      "small": "Малий",
      "normal": "Звичайний",
      "large": "Великий",
      "xl": "Дуже великий (XL)",
      "xxl": "Величезний (XXL)"
    }
  },
  "users": {
    "title": "Керування користувачами",
    "subtitle": "Керуйте користувачами організації, фільтруйте за активністю та оновіть реєстри доступу.",
    "searchUser": "Пошук користувача",
    "addUser": "Додати користувача",
    "editUser": "Редагувати користувача",
    "deleteUser": "Видалити користувача",
    "firstName": "Ім'я",
    "lastName": "Прізвище",
    "fullName": "Повне ім'я",
    "email": "Email",
    "password": "Пароль",
    "confirmPassword": "Підтвердити пароль",
    "enterEmail": "Введіть email",
    "userCreated": "Користувача створено успішно",
    "userUpdated": "Користувача оновлено успішно",
    "userDeleted": "Користувача видалено успішно",
    "confirmDeleteUser": "Ви впевнені, що хочете видалити цього користувача?",
    "projectSelection": {
      "archived": "Архівований",
      "noProjects": "Немає доступних проектів",
      "noProjectsDescription": "Немає доступних проектів для призначення",
      "errorLoadingProjects": "Помилка завантаження проектів"
    },
    "admin": "Адміністратор",
    "data_collector": "Збирач даних",
    "supervisor": "Супервізор",
    "user": "Користувач",
    "owner": "Власник",
    "isClient": "Клієнт",
    "active": "Активний",
    "inactive": "Неактивний",
    "refresh": "Оновити",
    "unsavedChanges": "Форма містить незбережені зміни. Ви впевнені, що хочете її закрити?",
    "validation": {
      "passwordRequired": "Пароль обов'язковий",
      "passwordMinLength": "Пароль повинен містити не менше 8 символів",
      "confirmPasswordRequired": "Будь ласка, підтвердіть пароль",
      "passwordsDontMatch": "Паролі не співпадають"
    },
    "editUserDescription": "Оновити дані користувача",
    "addUserDescription": "Створити нового користувача в системі",
    "basicInformation": "Основна інформація",
    "fullNamePlaceholder": "Введіть повне ім'я",
    "passwordSettings": "Налаштування пароля",
    "passwordPlaceholder": "Введіть пароль",
    "confirmPasswordPlaceholder": "Підтвердіть пароль",
    "passwordHelp": "Пароль повинен містити щонайменше 8 символів",
    "userSettings": "Налаштування користувача",
    "clientUserDescription": "Клієнтський користувач має обмежений доступ",
    "inactiveUserDescription": "Неактивні користувачі не можуть увійти в систему",
    "noName": "Без імені"
  },
  "user": {
    "system": "Система",
    "account": "Обліковий запис",
    "explore": "Огляд",
    "profile": "Профіль",
    "logout": "Вийти",
    "settings": "Налаштування",
    "projects": "Проекти",
    "faq": "Довідка",
    "helpAndSupport": "Довідка та підтримка",
    "administration": "Адміністрація",
    "help": "Довідка"
  },
  "odkSync": {
    "dashboard": {
      "title": "Панель синхронізації ODK"
    },
    "workbench": {
      "contextHint": "Слідкуйте за інтеграцією даних з серверів ODK та керуйте курсорами синхронізації в усій вашій організації.",
      "live": "Оновлення в реальному часі",
      "reconnect": "Перепідключитися",
      "loading": "Завантаження даних синхронізації…",
      "schedulerPill": "Планувальник",
      "schedulerActive": "Активний",
      "schedulerPaused": "Призупинений",
      "schedulerStopped": "Зупинений",
      "statusLive": "В реальному часі",
      "statusOffline": "Відключений",
      "statusSchedulerActive": "Активний",
      "statusSchedulerPaused": "Призупинений",
      "statusSchedulerStopped": "Зупинений",
      "createShort": "Створити",
      "pipeline": {
        "ariaLabel": "Статус підключення синхронізації",
        "scheduler": "Планувальник",
        "schedulerActive": "Виконується відповідно до плану",
        "schedulerPaused": "Призупинено — відправлення не синхронізуються",
        "pull": "Останнє оновлення",
        "cursors": "Курсори",
        "cursorsHint": "{count} форм слідкує",
        "cursorsEmpty": "Немає курсорів"
      }
    },
    "table": {
      "emptyState": "Немає курсорів синхронізації. Створити один для початку синхронізації відправлень."
    },
    "scheduler": {
      "title": "Планувальник синхронізації",
      "pauseScheduler": "Призупинити планувальник",
      "resumeScheduler": "Відновити планувальник",
      "pausedMessage": "Синхронізація даних ODK зараз призупинена. Нові відправлення не будуть синхронізовані до відновлення."
    },
    "managerScope": {
      "title": "Перегляд даних синхронізації",
      "message": "Ви переглядаєте дані синхронізації для {count} проекту(в) які ви керуєте. Ви можете переглядати та керувати синхронізацією тільки для проектів, де у вас є роль менеджера."
    },
    "statistics": {
      "title": "Статистика синхронізації",
      "totalCursors": "Всього курсорів",
      "lastSync": "Остання синхронізація"
    },
    "cursors": {
      "title": "Курсори синхронізації",
      "viewModes": {
        "cards": "Картки",
        "table": "Таблиця",
        "projects": "За проектами",
        "list": "Список"
      },
      "actions": {
        "clear": "Очистити",
        "bulkSync": "Масове синхронізація ({count})",
        "bulkReset": "Масовий скидання ({count})",
        "createCursor": "Створити курсор"
      }
    },
    "auto": {
      "managed": "Авто",
      "manual": "Ручний",
      "enableAuto": "Увімкнути авто ({count})",
      "disableAuto": "Вимкнути авто ({count})",
      "reason": "Причина",
      "reasons": {
        "importedActive": "Імпортована активна форма",
        "createdActive": "Створена активна форма",
        "uploadedActive": "Завантажена активна форма",
        "formOpened": "Форма відкрита",
        "formClosed": "Форма закрита",
        "formReopened": "Форма перевідкрита",
        "newFormOpened": "Нова форма відкрита",
        "migrated": "Мігровано",
        "formNotFound": "Форма не знайдена",
        "manualOverride": "Ручне керування",
        "formDeleted": "Форма видалена",
        "importedFormDeleted": "Імпортована форма видалена"
      }
    },
    "projectSummary": {
      "forms": "Форм: {count}",
      "lastSync": "Остання синхронізація",
      "active": "Активних: {count}",
      "errors": "Помилок: {count}",
      "inactive": "Неактивних: {count}",
      "noProjects": "Немає проектів",
      "createFirstCursor": "Створіть перший курсор синхронізації"
    },
    "projectResponsible": {
      "responsible": "Відповідальний",
      "notAssigned": "Не призначений",
      "assign": "Призначити",
      "remove": "Прибрати",
      "assignModal": {
        "title": "Призначити відповідального для проекту \"{project}\"",
        "selectUser": "Вибрати користувача",
        "selectUserPlaceholder": "Вибрати відповідального",
        "assign": "Призначити",
        "noUsers": "Немає доступних користувачів",
        "noUsersMessage": "В організації немає користувачів для призначення відповідальним за проект."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Створити курсор синхронізації",
        "server": "Сервер",
        "project": "Проект",
        "xmlForm": "XML Форма",
        "serverPlaceholder": "Вибрати сервер",
        "projectPlaceholder": "Вибрати проект",
        "xmlFormPlaceholder": "Вибрати форму"
      },
      "manualSync": {
        "title": "Ручна синхронізація",
        "selectCursors": "Вибрати курсори",
        "forceFullSync": "Примусова повна синхронізація",
        "maxConcurrent": "Максимум одночасних синхронізацій",
        "startSync": "Почати синхронізацію"
      }
    },
    "messages": {
      "schedulerPaused": "Планувальник синхронізації ODK призупинено",
      "schedulerResumed": "Планувальник синхронізації ODK відновлено",
      "cursorCreated": "Курсор синхронізації успішно створено",
      "manualSyncTriggered": "Ручну синхронізацію успішно запущено",
      "cursorReset": "Курсор успішно скинуто",
      "bulkResetSuccess": "Успішно скинуто {count} курсорів",
      "selectCursorsForSync": "Будь ласка, виберіть хоча б один курсор для синхронізації",
      "never": "Ніколи"
    },
    "errors": {
      "failedToLoadSyncData": "Не вдалося завантажити дані синхронізації",
      "failedToControlScheduler": "Не вдалося керувати планувальником",
      "failedToCreateCursor": "Не вдалося створити курсор синхронізації",
      "failedToTriggerManualSync": "Не вдалося запустити ручну синхронізацію",
      "failedToResetCursor": "Не вдалося скинути курсор",
      "failedToResetSomeCursors": "Не вдалося скинути деякі курсори"
    },
    "filters": {
      "showAllForms": "Показати всі форми",
      "filteringTitle": "Фільтрація форм",
      "filteringMessage": "Показано {filtered} з {total} форм. Приховано {hidden} форм зі статусами 'закрита', 'невідомий' або без визначеного статусу."
    },
    "formStatus": {
      "title": "Статус форм та оптимізація",
      "checkStatuses": "Перевірити статуси",
      "statusLabels": {
        "open": "Відкриті",
        "closing": "Закриваються",
        "closed": "Закриті",
        "unknown": "Невідомо"
      },
      "cards": {
        "title": "Статус форм",
        "description": "Перевірити та оптимізувати курсори",
        "refresh": "Оновити"
      },
      "loading": "Завантаження...",
      "autoCheckInterval": "5 хвилин",
      "lastCheck": "Автоматично кожні 5 хвилин",
      "benefits": {
        "autoDisable": "Автоматичне відключення курсорів для закритих форм",
        "resourceOptimization": "Оптимізація ресурсів синхронізації",
        "performanceImprovement": "Покращена продуктивність"
      },
      "messages": {
        "checkStarted": "Перевірка статусу форм запущена",
        "checkError": "Помилка при перевірці статусу форм",
        "enableError": "Помилка при увімкненні курсорів",
        "disableError": "Помилка при вимкненні курсорів"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "QC Dashboard - Якість даних ODK",
      "description": "Моніторинг якості даних ODK submissions за допомогою правил валідації"
    },
    "statistics": {
      "totalRules": "Всього правил",
      "activeRules": "Активних правил",
      "inactiveRules": "Неактивних правил",
      "recentValidations": "Останніх перевірок"
    },
    "sections": {
      "rulesByType": "Правила за типом",
      "rulesBySeverity": "Правила за рівнем серйозності",
      "qcRules": "QC Правила"
    },
    "filters": {
      "allTypes": "Всі типи",
      "allLevels": "Всі рівні",
      "allStatuses": "Всі статуси",
      "active": "Активний",
      "inactive": "Неактивний"
    },
    "actions": {
      "createRule": "Створити правило",
      "activate": "Активувати",
      "deactivate": "Деактивувати",
      "clearSelection": "Очистити вибір"
    },
    "ruleTypes": {
      "required": "Обов'язкове",
      "constraint": "Обмеження",
      "calculation": "Обчислення",
      "custom": "Користувацьке"
    },
    "severityLevels": {
      "error": "Помилка",
      "warning": "Попередження",
      "info": "Інформація"
    },
    "messages": {
      "noRuleTypeData": "Немає даних про типи правил",
      "noSeverityData": "Немає даних про серйозність правил",
      "ruleUpdated": "Правило оновлено",
      "ruleCreated": "Правило створено",
      "ruleSaveError": "Помилка збереження правила",
      "ruleLoadError": "Помилка завантаження даних",
      "ruleStatusToggled": "Статус правила {ruleName} змінено",
      "ruleStatusError": "Помилка зміни статусу правила",
      "confirmDeleteRule": "Видалити правило \"{ruleName}\"?",
      "ruleDeleted": "Правило видалено",
      "ruleDeleteError": "Помилка видалення правила",
      "ruleSaved": "Правило збережено",
      "bulkStatusToggled": "Статус змінено для {count} правил",
      "bulkStatusError": "Помилка зміни статусу правил",
      "bulkDeleted": "Видалено {count} правил",
      "bulkDeleteError": "Помилка видалення правил",
      "rulesDeleted": "Правила видалено",
      "rulesActivated": "Правила активовано",
      "rulesDeactivated": "Правила деактивовано",
      "ruleNotFound": "Правило не знайдено",
      "invalidJsonFormat": "Невірний формат JSON",
      "createExpressionFirst": "Спочатку створіть вираз",
      "previewError": "Помилка під час попереднього перегляду",
      "invalidRuleExpression": "Невірний вираз правила",
      "ruleNotExecuted": "Правило не виконано",
      "loadingRule": "Завантаження правила...",
      "saving": "Збереження...",
      "loading": "Завантаження...",
      "run": "Запустити",
      "passed": "Пройдено",
      "failed": "Провалено",
      "success": "Успішно",
      "errorDuringValidation": "Помилка під час валідації",
      "noQcRulesFound": "QC правила не знайдено"
    },
    "form": {
      "ruleName": "Назва правила",
      "ruleNameRequired": "Назва правила обов'язкова",
      "fieldPath": "Основне поле",
      "fieldPathRequired": "Основне поле обов'язкове",
      "fieldPathHint": "Головне поле, яке перевіряє це правило. В JSONLogic виразі можна використовувати інші поля.",
      "errorMessage": "Повідомлення про помилку",
      "errorMessageHint": "Показується перевіряючим при помилці цього правила.",
      "errorMessageRequired": "Повідомлення про помилку обов'язкове",
      "constraintExpression": "Вираз обмеження",
      "constraintExpressionHint": "Використовуйте '{'\"var\": \"field_name\"'}' для посилання на поля надсилання. Натисніть Застосувати для перевірки JSON.",
      "constraintExpressionRequired": "Вираз обмеження обов'язковий",
      "ruleType": "Тип правила",
      "severityLevel": "Рівень серйозності",
      "ruleActive": "Правило активне",
      "ruleActiveHint": "Неактивні правила зберігаються, але не застосовуються під час перевірки.",
      "basicSettings": "Основні налаштування",
      "jsonLogicBuilder": "Конструктор JSONLogic",
      "jsonLogicBuilderHint": "Визначає, коли це правило проходить. Вираз повинен оцінюватися як true для дійсних надсилань.",
      "reset": "Скинути",
      "apply": "Застосувати",
      "saveChanges": "Зберегти зміни",
      "createRule": "Створити правило",
      "editRule": "Редагувати правило",
      "rulePreview": "Попередній перегляд правила",
      "testRuleOnSample": "Тестувати правило на зразкових даних",
      "detailedResults": "Детальні результати",
      "showSubmissionData": "Показати дані надсилання",
      "help": "Допомога",
      "ruleTypes": "Типи правил",
      "severityLevels": "Рівні серйозності",
      "requiredField": "Обов'язкове поле",
      "constraintCheck": "Перевірка обмеження",
      "calculatedField": "Обчислюване поле",
      "customLogic": "Користувацька логіка",
      "blocksSubmission": "Блокує надсилання",
      "showsWarning": "Показує попередження",
      "informationalMessage": "Інформаційне повідомлення",
      "jsonLogicExamplesTitle": "Приклади JSONLogic виразів для hh_question:",
      "agreementCheckExample": "Перевірка згоди:",
      "finalStatusCheckExample": "Перевірка фінального статусу:",
      "enumeratorCheckExample": "Перевірка перелічувача:",
      "complexLogicExample": "Складна логіка:",
      "fieldValue": "Значення поля",
      "previewStatsLine": "{passed} пройдено · {failed} не пройдено · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Пошук за назвою, полем або повідомленням...",
      "ruleType": "Тип правила",
      "severityLevel": "Рівень серйозності",
      "status": "Статус",
      "enterRuleName": "Введіть назву правила",
      "enterErrorMessage": "Введіть повідомлення про помилку",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Вимкнути правило",
        "enableRule": "Увімкнути правило"
      }
    },
    "viewModes": {
      "cards": "Картки",
      "table": "Таблиця"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "Моніторинг очищення даних ODK",
      "subtitle": "Моніторинг системи автоматичного очищення та перегляд статистики даних",
      "selectFormTitle": "Виберіть форму для моніторингу очищення",
      "currentProject": "Поточний проект",
      "searchPlaceholder": "Пошук та вибір форми...",
      "systemInfo": {
        "title": "Система автоматичного очищення",
        "activeFormsTitle": "Активні форми (відкриті/закриваються)",
        "activeFormsDesc": "Автоматично залишаються лише 5 останніх папок. Очищення відбувається під час кожної синхронізації.",
        "closedFormsTitle": "Закриті форми (закриті)",
        "closedFormsDesc": "При закритті форми автоматично архівуються 4 папки, залишається 1 для статистики.",
        "monitoringTitle": "Моніторинг",
        "monitoringDesc": "Виберіть форму вище для перегляду статистики та моніторингу роботи системи очищення."
      }
    },
    "manager": {
      "title": "Менеджер очищення даних ODK",
      "loading": "Завантаження даних очищення...",
      "noData": {
        "title": "Дані відсутні",
        "meaning": "Що це означає:",
        "noSubmissions": "У цієї форми ще немає надсилань",
        "noSync": "Форма ще не була синхронізована з ODK Central",
        "noCleanupNeeded": "Очищення на даний момент не потрібне"
      },
      "errorLoading": "Помилка завантаження даних",
      "stats": {
        "title": "Поточна статистика",
        "totalFolders": "Всього папок",
        "totalSize": "Загальний розмір",
        "completeData": "Повні дані"
      },
      "formInfo": {
        "title": "Інформація про форму",
        "state": "Стан:",
        "active": "Активна:",
        "lastSubmission": "Останнє надсилання:",
        "lastSync": "Остання синхронізація:",
        "yes": "Так",
        "no": "Ні"
      },
      "recommendation": {
        "title": "Рекомендація щодо очищення",
        "action": "Дія:",
        "reason": "Причина:",
        "requiresApproval": "Потрібне підтвердження для очищення"
      },
      "buttons": {
        "refresh": "Оновити статистику",
        "dryRun": "Тестовий запуск",
        "cleanupNow": "Очистити зараз",
        "forceCleanup": "Примусове очищення"
      },
      "results": {
        "title": "Результат останнього очищення",
        "strategy": "Стратегія:",
        "kept": "Залишено: {count} папок",
        "deleted": "Видалено: {count} папок",
        "archived": "Архівовано: {count} папок",
        "skipped": "Пропущено: {count} папок"
      },
      "folders": {
        "title": "Останні папки ({count})",
        "columns": {
          "name": "Назва папки",
          "created": "Створена",
          "size": "Розмір (МБ)",
          "files": "Файли"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Глобальне очищення успішно завершено",
      "globalCleanupFailed": "Помилка глобального очищення",
      "errorLoadingProjects": "Помилка завантаження проектів",
      "errorLoadingForms": "Помилка завантаження форм",
      "noDataOrSync": "У цієї форми немає даних або вона ще не синхронізована",
      "statsLoadFailed": "Не вдалося завантажити статистику очищення",
      "dryRunSuccess": "Тестовий запуск завершено - файли не були видалені",
      "dryRunFailed": "Помилка тестового запуску",
      "cleanupNotRecommended": "Очищення не рекомендується для цієї форми",
      "cleanupSuccess": "Очищення успішно завершено",
      "cleanupFailed": "Помилка очищення",
      "forceNotAvailable": "Примусове очищення недоступне для цієї форми",
      "forceConfirm": "Ви впевнені, що хочете виконати примусове очищення? Цю дію не можна скасувати.",
      "forceSuccess": "Примусове очищення успішно завершено",
      "forceFailed": "Помилка примусового очищення"
    }
  },
  "permissionGroups": {
    "create": "Створити групу",
    "delete": "Видалити групу",
    "assignToUser": "Призначити групу користувачу",
    "removeFromUser": "Видалити групу у користувача",
    "roleNames": {
      "manager": "Менеджер",
      "projectMember": "Учасник проєкту",
      "dataViewer": "Переглядач даних",
      "dataCollector": "Збирач даних",
      "dataDownloader": "Завантажувач даних",
      "dataAnalyst": "Аналітик даних",
      "qcViewer": "Переглядач QC",
      "qcEditor": "Редактор QC",
      "monitor": "Монитор",
      "formDesigner": "Дизайнер форм"
    },
    "userManagement": {
      "clientGroups": "Групи клієнтів",
      "clientGroupsDescription": "Групи для зовнішніх користувачів або клієнтського доступу.",
      "regularGroups": "Звичайні групи",
      "regularGroupsDescription": "Групи для внутрішніх учасників проекту.",
      "errorTitle": "Не вдалося завантажити групи",
      "noProjectsTitle": "Спочатку виберіть проект",
      "noProjectsDescription": "Виберіть проект перед призначенням груп дозволів.",
      "noGroupsTitle": "Немає доступних груп",
      "noGroupsAvailable": "Немає доступних груп для призначення",
      "errorLoadingGroups": "Помилка завантаження груп",
      "selectedGroups": "Вибрані групи",
      "selectedCount": "Вибрано: {count}",
      "selectedPill": "Вибрано",
      "includedPermissions": "Включені дозволи",
      "groupDetailsTitle": "Деталі групи",
      "groupDescriptionFallback": "Опис не вказано.",
      "rolesCount": "Ролей: {count}",
      "viewGroupDetails": "Показати ролі групи {name}"
    }
  },
  "menu": {
    "dashboard": "Панель керування",
    "my-organization": "Моя організація",
    "userManagement": "Керування користувачами",
    "organizationStats": "Статистика організації",
    "organizationSettings": "Налаштування організації",
    "projects": "Проекти",
    "odkServers": "ODK Сервери",
    "odkSync": "ODK Синхронізація",
    "payments": "Платежі",
    "faq": "Довідка",
    "preferences": "Налаштування акаунту",
    "settings": "Налаштування додатку",
    "billing": "Білінг",
    "help": "Довідка"
  },
  "organization": {
    "settingsSubtitle": "Керування профілем організації, підпискою AI, картами та підключеною інфраструктурою.",
    "profile": {
      "sectionTitle": "Профіль організації",
      "name": "Назва",
      "description": "Опис",
      "edit": "Редагувати",
      "editTitle": "Редагування організації",
      "noDescription": "Опис не вказано",
      "created": "Створено",
      "updated": "Оновлено",
      "loadError": "Не вдалося завантажити профіль організації"
    },
    "infrastructure": {
      "sectionTitle": "Підключена інфраструктура",
      "subtitle": "Зведення серверів, проєктів, користувачів та активних форм.",
      "servers": "ODK-сервери",
      "projects": "Проєкти",
      "users": "Користувачі",
      "activeForms": "Активні форми",
      "defaultServer": "Сервер ODK за замовчуванням",
      "noDefaultServer": "Сервер за замовчуванням не вибрано",
      "manageServers": "Керування ODK-серверами",
      "viewSync": "Відкрити Sync Workbench",
      "loadError": "Не вдалося завантажити зведення інфраструктури"
    },
    "quickLinks": {
      "sectionTitle": "Пов'язані розділи",
      "userManagement": "Керування користувачами",
      "statistics": "Статистика організації",
      "projects": "Проєкти",
      "odkServers": "ODK-сервери",
      "syncWorkbench": "Синхронізація"
    }
  },
  "preferences": {
    "title": "Налаштування",
    "subtitle": "Перегляд профілю облікового запису, доступу до організації, груп дозволів та ролей проекту.",
    "accessOverview": "Огляд доступу",
    "organizationOwner": "Власник організації",
    "organizationOwnerDescription": "У вас повний доступ до всіх ресурсів та проектів організації.",
    "permissionGroups": "Групи прав",
    "permissionGroupsDescription": "Групи за проектами та їхні ролі",
    "perProject": "За проектом",
    "noProjectGroups": "Немає груп, прив'язаних до проекту.",
    "projectsAccess": "Доступ до проектів",
    "projectsAccessDescription": "Проекти, які ви можете відкрити, та ваші ролі",
    "ownerNoProjects": "Як власник організації ви маєте повний доступ. Проекти з’являться після створення або імпорту.",
    "noProjectAccess": "Доступ до проектів поки не надано.",
    "projectIdLabel": "ID: {id}",
    "projectLabelFallback": "Проект #{id}",
    "memberSince": "Учасник з:",
    "userFallback": "Користувач",
    "invalidDate": "Недопустима дата",
    "name": "Ім'я",
    "email": "Ел. пошта",
    "password": "Пароль",
    "resetPassword": "Скинути пароль",
    "emailSubscriptions": "Підписки на e-mail",
    "emailSubscriptionsVisit": "Щоб керувати розсилкою, перейдіть до",
    "notificationSettingsLink": "Налаштування сповіщень",
    "cancelAccount": "Видалити обліковий запис",
    "cancelAccountDescription": "Безповоротно видалити організацію, користувачів та всі пов’язані дані.",
    "cancelAccountAction": "Видалити обліковий запис",
    "editName": "Змінити ім'я",
    "editNameSubtitle": "Ім’я, що відображається в додатку.",
    "nameRequired": "Вкажіть ім’я",
    "nameMinLength": "Ім’я має містити щонайменше 2 символи",
    "nameUpdateFailed": "Не вдалося оновити ім’я. Спробуйте знову.",
    "nameChangedSuccess": "Ім'я успішно змінено",
    "resetPasswordTitle": "Скидання пароля",
    "resetPasswordSubtitle": "Введіть поточний пароль і задайте новий.",
    "passwordRequirementsTitle": "Вимоги до пароля",
    "currentPassword": "Поточний пароль",
    "newPassword": "Новий пароль",
    "repeatNewPassword": "Повторіть новий пароль",
    "passwordMinLength": "Не менше 8 символів",
    "passwordUniqueChars": "Не менше 6 унікальних символів",
    "updatePassword": "Оновити пароль",
    "passwordChangedSuccess": "Пароль успішно змінено",
    "passwordUpdateFailed": "Не вдалося оновити пароль. Спробуйте знову.",
    "currentPasswordRequired": "Обов'язково вкажіть поточний пароль",
    "newPasswordRequired": "Обов'язково вкажіть новий пароль",
    "repeatPasswordRequired": "Обов'язково повторіть новий пароль",
    "passwordMatchUnique": "Новий пароль не повинен збігатися з поточним",
    "confirmPasswordMismatch": "Підтвердження не збігається з новим паролем",
    "dangerZoneTitle": "Небезпечна зона",
    "dangerZoneSubtitle": "Необоротні дії, що стосуються всієї організації.",
    "cancelAccountModalTitle": "Видалення облікового запису",
    "cancelAccountModalSubtitle": "Підтвердіть особу та згоду на безповоротне видалення облікового запису.",
    "cancelAccountConsequenceOrg": "Організацію та всі проєкти буде видалено",
    "cancelAccountConsequenceUsers": "Усі учасники організації втратять доступ",
    "cancelAccountConsequenceOdk": "Пов’язані дані ODK можуть бути безповоротно видалені",
    "cancelAccountConsequenceIrreversible": "Цю дію не можна скасувати",
    "cancelAccountConfirmEmailLabel": "Введіть ваш email для підтвердження",
    "cancelAccountConfirmEmailRequired": "Підтвердження email обов’язкове",
    "cancelAccountConfirmEmailMismatch": "Email не збігається з вашим обліковим записом",
    "cancelAccountAcknowledge": "Я розумію, що це безповоротно видалить мою організацію та всі пов’язані дані",
    "cancelAccountAcknowledgeRequired": "Потрібно підтвердити розуміння наслідків",
    "cancelAccountDeleteButton": "Видалити обліковий запис безповоротно",
    "cancelAccountUnavailableTitle": "Видалення облікового запису поки недоступне",
    "cancelAccountUnavailableMessage": "Особу підтверджено. Функція видалення готується — зверніться до адміністратора або підтримки для закриття облікового запису.",
    "cancelAccountWrongPassword": "Невірний пароль. Спробуйте знову.",
    "dangerZoneCancelAccount": "Небезпечна зона: Видалення облікового запису",
    "cancelAccountWarning": "Це безповоротно видалить обліковий запис і всі пов’язані дані, включно з організацією, користувачами та даними ODK.",
    "groupFallback": "Група"
  },
  "faq": {
    "title": "Довідка",
    "subtitle": "Короткі посібники та відповіді на типові завдання в UDACAPI."
  },
  "settings": {
    "title": "Налаштування",
    "subtitle": "Налаштуйте зовнішній вигляд програми, мову та налаштування сповіщень.",
    "themeSection": "Тема",
    "generalSection": "Загальні налаштування",
    "notificationsNoticeTitle": "Ваші налаштування сповіщень згруповані та спрощені",
    "notificationsNoticeBody": "Ваші попередні вибори налаштувань не змінені."
  },
  "projects": {
    "pageTitle": "Проекти",
    "subtitle": "Керуйте своїми проектами, переключайтеся між картками та таблицями та запускайте потоки імпорту або створення.",
    "refresh": "Оновити",
    "createProject": "Створити проект",
    "importRestrictions": {
      "message": "Імпорт проектів дозволений лише на серверах, які належать організації. Сервери Shared і Global не можуть бути використані для імпорту проектів."
    },
    "viewMode": {
      "cards": "Картки",
      "table": "Таблиця"
    },
    "sections": {
      "forms": {
        "title": "Форми проекту"
      },
      "users": {
        "title": "Користувачі проекту"
      },
      "formAccess": {
        "title": "Доступ до форм",
        "description": "Оберіть, які App Users можуть завантажувати кожну форму в ODK Collect.",
        "save": "Зберегти",
        "discard": "Скасувати",
        "saving": "Збереження…",
        "saved": "Доступ до форм збережено",
        "saveError": "Не вдалося зберегти всі зміни",
        "loadError": "Не вдалося завантажити доступ до форм",
        "emptyForms": "У проєкті немає опублікованих форм",
        "emptyAppUsers": "Ще немає App Users. Спочатку створіть QR-код.",
        "openQr": "Відкрити QR workbench",
        "openForms": "Відкрити форми",
        "dirtyHint": "Є незбережені зміни"
      },
      "info": {
        "title": "Інформація про проєкт",
        "basicInfo": "Основна інформація",
        "accessInfo": "Доступ",
        "statistics": "Статистика проєкту",
        "fields": {
          "projectId": "ID проєкту",
          "name": "Назва",
          "description": "Опис",
          "status": "Статус",
          "orgId": "ID організації",
          "odkProjectId": "ODK Project ID",
          "createdAt": "Дата створення",
          "updatedAt": "Останнє оновлення",
          "yourRole": "Ваша роль",
          "canManageForms": "Керування формами",
          "canViewUsers": "Перегляд користувачів",
          "isManager": "Менеджер",
          "isOwner": "Власник",
          "totalUsers": "Користувачі проєкту"
        },
        "status": {
          "active": "Активний",
          "archived": "Архівований"
        },
        "noDescription": "Опис не вказано",
        "loading": "Завантаження інформації про проєкт...",
        "loadError": "Не вдалося завантажити інформацію про проєкт",
        "statsLoadError": "Не вдалося завантажити статистику проєкту",
        "invalidDate": "Некоректна дата",
        "notAvailable": "Н/Д"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Додати користувача до проекту",
        "editTitle": "Редагувати доступ до проекту",
        "addSubtitle": "Спочатку виберіть користувача, а потім призначте йому групи дозволів для цього проекту.",
        "editSubtitle": "Перевірте вибраного користувача та оновіть групи дозволів для цього проекту.",
        "stepOne": "Крок 1",
        "stepTwo": "Крок 2",
        "stepReady": "Готово",
        "stepRequired": "Обов'язково",
        "stepLocked": "Недоступно",
        "selectUserTitle": "Виберіть користувача",
        "selectedUser": "Вибраний користувач",
        "selectUserHint": "Виберіть, кому потрібно надати доступ до цього проекту.",
        "selectedUserHint": "Цей користувач уже доданий до проекту. Нижче можна оновити його групи дозволів.",
        "selectUserPlaceholder": "Виберіть користувача",
        "selectUserHelper": "Власники та суперкористувачі не показуються в цьому списку.",
        "permissionGroupsTitle": "Групи дозволів",
        "permissionGroupsHint": "Виберіть одну або кілька груп дозволів для вибраного користувача.",
        "permissionGroupsLockedTitle": "Спочатку виберіть користувача",
        "permissionGroupsLockedHint": "Групи дозволів стануть доступними після вибору користувача.",
        "addToProject": "Додати до проекту",
        "clientUser": "Клієнт",
        "internalUser": "Внутрішній користувач"
      },
      "dialogs": {
        "removeUser": {
          "title": "Видалити користувача з проекту",
          "message": "Ви дійсно хочете видалити цього користувача з проекту?",
          "confirm": "Видалити"
        }
      },
      "list": {
        "searchPlaceholder": "Пошук користувачів",
        "filterByPermissionGroups": "Фільтр за групами дозволів",
        "accessDeniedTitle": "Немає доступу",
        "accessDeniedMessage": "У вас немає прав для перегляду користувачів цього проекту.",
        "loadErrorTitle": "Не вдалося завантажити користувачів проекту",
        "emptyTitle": "У проекті поки немає користувачів",
        "emptyMessage": "Додайте першого користувача, щоб почати керувати доступом до проекту.",
        "emptyFilteredTitle": "За поточними фільтрами користувачів не знайдено",
        "emptyFilteredMessage": "Спробуйте змінити текст пошуку або вибрані групи дозволів.",
        "noPermissionGroups": "Немає груп дозволів"
      },
      "messages": {
        "saveSuccess": "Доступ користувача до проекту успішно оновлено.",
        "removeSuccess": "Користувача видалено з проекту."
      },
      "errors": {
        "assignGroupsFailed": "Не вдалося призначити групи дозволів. Спробуйте ще раз.",
        "assignRoleFailed": "Не вдалося призначити роль проекту.",
        "loadUsersFailed": "Не вдалося завантажити користувачів проекту.",
        "permissionGroupsLoadFailed": "Не вдалося завантажити групи дозволів.",
        "projectMemberRoleFailed": "Не вдалося визначити роль project member.",
        "removeUserFailed": "Не вдалося видалити користувача з проекту.",
        "rolesLoadFailed": "Не вдалося завантажити ролі проекту.",
        "saveUserFailed": "Не вдалося оновити доступ до проекту."
      }
    },
    "modal": {
      "addProject": "Додати проект",
      "editProject": "Редагувати проект",
      "unsavedChanges": "Форма містить незбережені зміни. Ви впевнені, що хочете закрити її?"
    },
    "form": {
      "projectName": {
        "label": "Назва проекту",
        "placeholder": "Введіть назву проекту",
        "required": "Назва проекту обов'язкова"
      },
      "odkServer": {
        "label": "ODK Сервер",
        "placeholder": "Виберіть ODK сервер",
        "required": "ODK Сервер обов'язковий",
        "noServers": "Немає доступних ODK серверів. Будь ласка, спочатку додайте сервер."
      },
      "description": {
        "label": "Опис",
        "placeholder": "Необов'язковий опис проекту"
      },
      "buttons": {
        "cancel": "Скасувати"
      }
    },
    "cards": {
      "noProjects": "Немає проектів",
      "status": {
        "active": "Активний",
        "archived": "Архівований"
      }
    },
    "confirmations": {
      "odkServerRequired": "Будь ласка, додайте хоча б один ODK сервер перед створенням проекту.",
      "delete": {
        "imported": {
          "title": "Видалити імпортований проект",
          "message": "Ви впевнені, що хочете видалити проект \"{name}\"?\n\nЦей проект було імпортовано з ODK Central. Він буде видалений тільки з бази даних цього додатку, але залишиться на сервері ODK Central.",
          "messageWithStats": "Ви впевнені, що хочете видалити проект \"{name}\"?\n\nЦей проект містить {formsCount} форми та {submissionsCount} записів.\nПроект буде архівований/прихований (soft-delete), і дані будуть збережені.\n\nЦей проект було імпортовано з ODK Central. Він буде видалений тільки з бази даних цього додатку, але залишиться на сервері ODK Central."
        },
        "regular": {
          "title": "Видалити проект",
          "message": "Ви впевнені, що хочете видалити проект \"{name}\"?\n\nПОПЕРЕДЖЕННЯ: Це назавжди видалить проект з бази даних цього додатку та з сервера ODK Central.",
          "messageWithStats": "Ви впевнені, що хочете видалити проект \"{name}\"?\n\nЦей проект містить {formsCount} форми та {submissionsCount} записів.\nПроект буде архівований/прихований (soft-delete), і дані будуть збережені."
        },
        "confirmButton": "Видалити"
      }
    },
    "notifications": {
      "organizationNotSelected": "Організацію не вибрано"
    },
    "import": {
      "title": "Імпорт проектів ODK",
      "subtitle": "Завантажте існуючі проекти ODK з сервера організації та імпортуйте їх у цей робочий простір.",
      "selectServer": "Виберіть сервер ODK",
      "getProjects": "Отримати проекти",
      "availableProjects": "Доступні проекти",
      "noProjectsFound": "Проекти не знайдено на вибраному сервері.",
      "importProject": "Імпортувати",
      "imported": "Імпортовано",
      "errors": {
        "serversLoadFailed": "Не вдалося завантажити сервери ODK. Будь ласка, спробуйте пізніше.",
        "projectsLoadFailed": "Не вдалося завантажити проекти з сервера ODK. Будь ласка, перевірте з'єднання та спробуйте знову.",
        "importFailed": "Не вдалося імпортувати проект. Будь ласка, спробуйте пізніше.",
        "importError": "Помилка при імпорті проекту: {detail}"
      }
    },
    "importForms": {
      "title": "Імпорт форм ODK",
      "subtitle": "Виберіть форми з вашого проєкту ODK Central, щоб додати їх сюди.",
      "subtitleWithProject": "Виберіть форми з проєкту Central {odkProjectId}, щоб додати їх до «{name}».",
      "loadingForms": "Завантаження форм з сервера ODK...",
      "availableForms": "Доступні форми",
      "searchForms": "Пошук форм...",
      "selectAll": "Вибрати все",
      "deselectAll": "Скасувати вибір",
      "importSelected": "Імпортувати вибрані",
      "noFormsFound": "Форми не знайдено для цього проекту на сервері ODK.",
      "errors": {
        "projectNotLinked": "Проект не пов'язаний з сервером ODK",
        "formsLoadFailed": "Не вдалося завантажити форми з сервера ODK. Будь ласка, спробуйте пізніше.",
        "formsLoadError": "Помилка при завантаженні форм: {detail}",
        "importFailed": "Не вдалося імпортувати форми. Будь ласка, спробуйте пізніше.",
        "importError": "Помилка імпорту: {detail}"
      },
      "status": {
        "imported": "Імпортовано",
        "available": "Доступна"
      },
      "progress": {
        "started": "Імпорт запущено",
        "completedSummary": "Форми готові в цьому проєкті.",
        "failedSummary": "Деякі форми не вдалося імпортувати. Деталі нижче.",
        "viewProject": "Відкрити проєкт",
        "forms": "{done} / {total} форм",
        "submissions": "{count} записів оброблено",
        "submissionsProgress": "{fetched} / {total} записів синхронізовано",
        "stages": {
          "queued": "Очікування запуску",
          "pending": "Очікування запуску",
          "importingForms": "Імпорт форм",
          "syncingData": "Синхронізація даних"
        },
        "messages": {
          "queued": "Завдання додано в чергу, очікування запуску...",
          "importingForms": "Імпорт метаданих форм..."
        }
      }
    },
    "detail": {
      "loading": "Завантаження проекту...",
      "returnToProjects": "Повернутися до проектів",
      "forms": {
        "title": "Форми проекту",
        "noForms": "У проекті відсутні форми.",
        "contactAdmin": "Зверніться до адміністратора для додавання форм.",
        "actions": {
          "publish": "Опублікувати",
          "abandon": "Відмовитися",
          "attachments": "Вкладення",
          "qrCode": "QR-код для тестування",
          "previewEnketo": "Перегляд в Enketo",
          "downloadTestData": "Завантажити тестові дані",
          "formSettings": "Налаштування форми",
          "viewDetails": "Перегляд/Деталі",
          "changeState": "Змінити статус",
          "delete": "Видалити/Відмовитися"
        },
        "modals": {
          "qrCode": {
            "title": "QR-код для тестування",
            "description": "Відскануйте QR-код, щоб протестувати форму"
          },
          "formSettings": {
            "title": "Налаштування форми",
            "basicSettings": "Основні налаштування (Placeholder)",
            "accessSettings": "Налаштування доступу (Placeholder)",
            "placeholder": "Це демонстраційний інтерфейс. Функціональність у розробці."
          }
        },
        "messages": {
          "tryAgain": "Спробувати знову",
          "publishing": "Публікація форми {name}...",
          "published": "Форма {name} успішно опублікована",
          "previewing": "Попередній перегляд {name} в Enketo (dev placeholder)",
          "downloading": "Завантаження тестових даних для {name} (dev placeholder)",
          "saving": "Збереження налаштувань для {name} (dev placeholder)",
          "missingData": "Не вистачає даних для імпорту форм",
          "missingXlsformData": "Не вистачає даних для завантаження XLSForm",
          "noAttachments": "У форми немає вкладень"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "ODK Сервери",
    "subtitle": "Керуйте серверами ODK організації, їхніми налаштуваннями, видимістю та станом з'єднання.",
    "addServer": "Додати сервер",
    "editServer": "Редагувати сервер",
    "deleteServer": "Видалити сервер",
    "modal": {
      "addSubtitle": "Підключіть сервер ODK Central до цієї організації.",
      "editSubtitle": "Оновіть параметри підключення до сервера."
    },
    "table": {
      "default": "За замовчуванням",
      "visibility": "Видимість",
      "setAsDefault": "Встановити за замовчуванням",
      "setAsDefaultTooltip": "Встановити як сервер за замовчуванням для цієї організації",
      "testConnection": "Тестувати підключення",
      "testConnectionTooltip": "Тестувати підключення до сервера ODK Central",
      "testConnectionDisabled": "Тестування підключення доступне тільки для серверів, що належать організації",
      "editServer": "Редагувати сервер",
      "editServerTooltip": "Редагувати деталі сервера (тільки для серверів ORGANIZATION та за наявності дозволів)",
      "deleteServer": "Видалити сервер",
      "deleteServerTooltip": "Видалити сервер (тільки для серверів ORGANIZATION та за наявності дозволів)",
      "odkSession": "Сесія ODK"
    },
    "session": {
      "banner": "У одного або кількох серверів закінчується або недійсна сесія ODK Central, або не збережено пароль. Відредагуйте сервер і збережіть пароль, щоб застосунок міг перепідключатися автоматично.",
      "ok": "Сесію в порядку",
      "expiresSoon": "Скоро закінчиться",
      "expired": "Закінчилась",
      "unknown": "Невідомо",
      "noStoredPassword": "Пароль не збережено"
    },
    "form": {
      "serverName": "Назва сервера",
      "serverUrl": "URL сервера",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Ім'я користувача",
      "password": "Пароль",
      "passwordPlaceholderEdit": "Залишити порожнім, щоб не змінювати",
      "description": "Опис",
      "serverIsActive": "Сервер активний",
      "serverIsActiveHint": "Неактивні сервери залишаються в списку, але не пропонуються при створенні проєктів."
    },
    "validation": {
      "serverNameRequired": "Назва сервера обов'язкова",
      "serverUrlRequired": "URL сервера обов'язковий",
      "urlFormatInvalid": "URL повинен починатися з http:// або https://",
      "usernameRequired": "Ім'я користувача обов'язкове",
      "passwordRequired": "Пароль обов'язковий"
    },
    "messages": {
      "selectOrganizationFirst": "Будь ласка, спочатку виберіть або створіть організацію",
      "loadingServers": "Завантаження серверів...",
      "noServersFound": "ODK сервери для цієї організації не знайдені",
      "failedToLoadServers": "Не вдалося завантажити сервери",
      "noServers": "Немає ODK серверів",
      "serverSaved": "Сервер \"{name}\" {action} успішно!",
      "serverSetAsDefault": "Сервер \"{name}\" встановлено за замовчуванням",
      "connectionTestSuccess": "Підключення успішне. Знайдено проектів: {count}",
      "connectionTestFailed": "Тест підключення не вдався"
    },
    "contextHint": "Підключіть сервер ODK перед синхронізацією або імпортом форм."
  },
  "notifications": {
    "all": "Дивитися всі",
    "less": "Дивитися менше"
  },
  "language": {
    "label": "Мова",
    "english": "Англійська",
    "spanish": "Іспанська",
    "french": "Французька",
    "swahili": "Суахілі",
    "portuguese": "Португальська",
    "ukrainian": "Українська",
    "russian": "Російська",
    "turkish": "Турецька"
  },
  "auth": {
    "createAccount": "Створити акаунт",
    "dontHaveAccount": "Немає акаунту?",
    "email": "Email",
    "emailInvalid": "Email повинен бути коректним",
    "emailRequired": "Поле Email обов'язкове",
    "enterEmail": "Введіть ваш email",
    "enterVerificationCode": "Будь ласка, введіть код підтвердження",
    "forgotPassword": "Забули пароль?",
    "forgotPasswordDescription": "Якщо ви забули пароль, не хвилюйтеся. Просто введіть ваш email нижче, і ми надішлемо вам лист з інструкціями по скиданню пароля. Відновлення доступу до вашого акаунту ніколи не було таким простим.",
    "fullName": "Повне ім'я",
    "fullNameRequired": "Поле Повне ім'я обов'язкове",
    "goBack": "Назад",
    "haveAccount": "Вже є акаунт?",
    "login": "Вхід",
    "password": "Пароль",
    "passwordMustContainLetter": "Пароль повинен містити хоча б одну літеру",
    "passwordMustContainNumber": "Пароль повинен містити хоча б одну цифру",
    "passwordMustContainSpecial": "Пароль повинен містити хоча б один спеціальний символ",
    "passwordMustBe8Chars": "Пароль повинен містити мінімум 8 символів",
    "passwordRequired": "Поле Пароль обов'язкове",
    "passwordRequirements": "Пароль повинен містити 8+ символів: літери, цифри та спеціальні символи.",
    "passwordsDontMatch": "Паролі не співпадають",
    "registrationFailed": "Реєстрація не вдалася. Спробуйте ще раз.",
    "registrationSuccess": "Ви успішно зареєструвалися! Будь ласка, перевірте ваш email для отримання інструкцій по активації.",
    "repeatPassword": "Повторіть пароль",
    "repeatPasswordRequired": "Поле Повторіть пароль обов'язкове",
    "resetInstructionsSent": "Інструкції по скиданню пароля надіслані на ваш email.",
    "resetInstructionsFailed": "Не вдалося надіслати email для скидання пароля. Спробуйте ще раз.",
    "resetPassword": "Скинути пароль",
    "sendResetInstructions": "Надіслати інструкції по скиданню",
    "signUp": "Зареєструватися",
    "twoFactorAuthentication": "Двофакторна аутентифікація",
    "verificationCode": "Код підтвердження",
    "verificationCodeRequired": "Код підтвердження обов'язковий",
    "verifyCode": "Підтвердити код"
  },
  "dashboard": {
    "subtitle": "Головна сторінка з візуалізаціями статистики та важливою інформацією.",
    "activeFormsTitle": "Активні форми",
    "activeFormsSubtitle": "Кількість та стан активних форм.",
    "noActiveForms": "Немає активних форм"
  },
  "qr": {
    "title": "QR-код (налаштування ODK Collect)",
    "titleShort": "QR-код",
    "qrName": "Назва QR-коду",
    "projectSection": "Проект",
    "projectName": "Назва проекту",
    "projectIcon": "Іконка проекту",
    "projectColor": "Колір проекту",
    "generalSection": "Загальні налаштування",
    "serverUrl": "URL сервера",
    "username": "Ім'я користувача",
    "password": "Пароль",
    "adminSection": "Налаштування адміністратора",
    "admin": {
      "edit_saved": "Редагувати збережене",
      "send_finalized": "Відправити завершений",
      "view_sent": "Переглянути відправлений",
      "password": "Пароль адміністратора",
      "advanced": "Розширений адмін",
      "getBlank": "Отримати порожній",
      "deleteSaved": "Видалити збережене",
      "qrCodeScanner": "Сканер QR-кодів",
      "changeServer": "Змінити сервер",
      "changeAppTheme": "Змінити тему додатку",
      "changeAppLanguage": "Змінити мову додатку",
      "changeFontSize": "Змінити розмір шрифту",
      "changeNavigation": "Змінити навігацію",
      "maps": "Карти",
      "periodicUpdates": "Періодичні оновлення",
      "automaticUpdate": "Автоматичне оновлення",
      "hideOldVersions": "Приховати старі версії",
      "changeAutosend": "Змінити автонадсилання",
      "deleteAfterSend": "Видалити після надсилання",
      "defaultToFinalized": "За замовчуванням завершений",
      "changeConstraintBehavior": "Змінити поведінку обмежень",
      "highResolution": "Висока роздільність",
      "imageSize": "Розмір зображення",
      "guidanceHint": "Підказка",
      "externalAppRecording": "Запис зовнішнім додатком",
      "instanceFormSync": "Синхронізація екземплярів форми",
      "changeFormMetadata": "Змінити метадані форми",
      "analytics": "Аналітика",
      "movingBackwards": "Рух назад",
      "accessSettings": "Доступ до налаштувань",
      "changeLanguage": "Змінити мову",
      "jumpTo": "Перейти до",
      "saveMid": "Зберегти проміжний",
      "saveAs": "Зберегти як",
      "markAsFinalized": "Позначити як завершений"
    },
    "actions": {
      "generate": "Створити QR-код",
      "downloadPng": "Завантажити PNG",
      "copyBase64": "Копіювати Base64",
      "reset": "Скинути",
      "importJson": "Імпорт JSON"
    },
    "placeholder": "Згенеруйте QR-код, щоб побачити його тут",
    "note": "Код містить zlib-стиснений Base64 JSON з general/admin/project. Авторизація App User — у server_url.",
    "general": {
      "theme": "Тема",
      "language": "Мова",
      "fontSize": "Розмір шрифту",
      "navigation": "Навігація",
      "constraintBehavior": "Поведінка обмежень",
      "advanced": "Розширені загальні",
      "formlistUrl": "URL списку форм",
      "submissionUrl": "URL надсилання",
      "periodicUpdates": "Періодичні оновлення",
      "deleteAfterSend": "Видалити після надсилання",
      "defaultCompleted": "За замовчуванням завершений",
      "externalAppRecording": "Запис зовнішнім додатком"
    },
    "formManagement": {
      "title": "Керування формами",
      "updateMode": "Режим оновлення",
      "autosend": "Автонадсилання",
      "imageSize": "Розмір зображення",
      "automaticUpdate": "Автоматичне оновлення",
      "hideOldVersions": "Приховати старі версії",
      "instanceSync": "Синхронізація екземплярів",
      "guidanceHint": "Підказка",
      "highResolution": "Висока роздільність"
    },
    "maps": {
      "title": "Карти",
      "basemap": "Базова карта",
      "googleStyle": "Стиль Google",
      "mapboxStyle": "Стиль Mapbox",
      "usgsStyle": "Стиль USGS",
      "cartoStyle": "Стиль CARTO",
      "referenceLayer": "Опорний шар (шлях)"
    },
    "identity": {
      "title": "Ідентичність",
      "analytics": "Аналітика",
      "userName": "Ім'я користувача",
      "email": "Ел. пошта",
      "phone": "Телефон"
    },
    "presets": {
      "title": "Шаблони QR",
      "save": "Зберегти шаблон",
      "load": "Завантажити шаблон...",
      "delete": "Видалити",
      "defaultName": "Шаблон {number}"
    },
    "preview": {
      "title": "Попередній перегляд JSON",
      "reset": "Скинути",
      "import": "Імпорт"
    },
    "history": {
      "title": "Згенеровані QR-коди",
      "viewAll": "Переглянути все",
      "view": "Переглянути",
      "download": "Завантажити",
      "copy": "Копіювати",
      "delete": "Видалити",
      "more": "... та ще {count}"
    },
    "placeholders": {
      "qrName": "QR мого пристрою",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "icon": "📋",
      "projectName": "Польова команда"
    },
    "options": {
      "default": "За замовчуванням",
      "system": "Система"
    },
    "messages": {
      "nameRequiredForPreset": "Введіть назву для шаблону",
      "nameRequiredForAppUser": "Назва QR-коду потрібна для створення користувача додатку",
      "invalidSettings": "Невірні налаштування",
      "generateError": "Не вдалося згенерувати QR та створити користувача додатку",
      "invalidJsonStructure": "Невірна структура JSON. Повинні бути секції project, general та admin.",
      "invalidJsonFormat": "Невірний формат JSON",
      "copyBase64Error": "Не вдалося скопіювати Base64",
      "projectNameRequired": "Назва проєкту обов’язкова",
      "serverRequired": "URL сервера обов’язковий",
      "missingOdkProject": "У проєкту немає ODK Central project id. Повторно імпортуйте або перевірте налаштування.",
      "generateSuccess": "QR згенеровано, App User створено",
      "presetSaved": "Шаблон збережено",
      "base64Copied": "Base64 скопійовано",
      "jsonImported": "Налаштування імпортовано з JSON"
    },
    "workbench": {
      "contextHint": "Створіть QR для ODK Collect із токеном App User у URL сервера.",
      "serverReady": "Сервер задано",
      "essentialsTitle": "Налаштування",
      "essentialsDesc": "Назвіть QR і картку Collect, оберіть іконку та колір, потім згенеруйте.",
      "nameHint": "Також використовується як display name App User в ODK Central.",
      "serverHint": "Береться зі звʼязаного ODK-сервера проєкту. При генерації підставляється /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Розширені опції Collect",
      "advancedHint": "Тема, синхронізація форм, карти — за бажанням",
      "previewTitle": "Перегляд",
      "previewDesc": "Відскануйте в ODK Collect після генерації.",
      "libraryHint": "Зберігається в цьому браузері для цього проєкту.",
      "libraryEmpty": "QR-кодів ще немає. Згенеруйте перший.",
      "libraryCount": "{count} у бібліотеці",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: не привʼязано — перевірте ODK-сервер проєкту",
      "projectNameHint": "Підпис у ODK Collect для цієї конфігурації (не імʼя проєкту в udacapi).",
      "iconHint": "Показується на картці проєкту в Collect. Типового значення зазвичай достатньо.",
      "changeIcon": "Змінити іконку",
      "iconDialogTitle": "Іконка проєкту Collect",
      "iconDialogSubtitle": "Оберіть один символ для картки проєкту на пристрої.",
      "applyIcon": "Застосувати"
    },
    "formAccess": {
      "title": "Форми, доступні цьому збирачу",
      "hint": "Оберіть щонайменше одну опубліковану форму. Інакше Collect покаже порожній список.",
      "selectAll": "Вибрати все",
      "clear": "Очистити",
      "required": "Оберіть щонайменше одну форму",
      "assignFailed": "Не вдалося призначити форми App User",
      "manageAll": "Керувати всім доступом до форм",
      "formsCount": "{n} форм",
      "noPublishedForms": "У цьому проєкті ще немає опублікованих форм."
    }
  },
  "forms": {
    "state": {
      "open": "Відкрита",
      "closing": "Закривається",
      "closed": "Закрита",
      "draft": "Чернетка"
    },
    "deleteConfirm": {
      "title": "Видалити форму",
      "subtitle": "Перевірте наслідки перед остаточним видаленням цієї форми.",
      "message": "Цю дію не можна скасувати.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Видалити назавжди",
      "importedWarning": "Ця форма була імпортована з ODK Central. Вона буде видалена тільки з бази даних цього додатку та залишиться на сервері ODK Central.",
      "regularWarning": "Ця дія переміщує форму до корзини ODK Central та позначає її як видалену локально.",
      "consequenceDataLoss": "Усі відповіді та історія експорту цієї форми будуть видалені з додатку.",
      "irreversible": "Ця дія не може бути скасована через інтерфейс.",
      "success": "Форма {name} видалена.",
      "successImported": "Форма {name} видалена тільки з бази даних цього додатку.",
      "error": "Помилка при видаленні форми: {error}"
    },
    "uploadXlsform": {
      "title": "Завантажити XLSForm",
      "subtitle": "Виберіть файл (.xlsx або .xls, до 50 МБ) для створення або оновлення форми.",
      "selectFile": "Вибрати XLSForm файл",
      "dropFileTitle": "Перетягніть XLSForm сюди",
      "supportedFormats": "Формати: .xlsx та .xls, до 50 МБ.",
      "replaceFileHint": "Виберіть інший файл, щоб замінити поточний.",
      "chooseFile": "Вибрати файл",
      "selectedFile": "Вибраний файл:",
      "formSettings": "Ідентифікатор форми",
      "uploadOptions": "Параметри завантаження",
      "formId": "ID форми",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "Унікальний ID форми (лише літери, цифри та підкреслення)",
      "formIdWarning": {
        "title": "Важливо!",
        "message": "ID форми буде автоматично взятий з XLSForm ('settings' листа). Це поле використовується лише як резервний варіант."
      },
      "updateExisting": "Оновити існуючу форму",
      "updateExistingHint": "Якщо форма з таким ID вже існує, вона буде оновлена",
      "ignoreWarnings": "Ігнорувати попередження",
      "ignoreWarningsHint": "Ігнорувати попередження під час конвертації",
      "publishImmediately": "Опублікувати форму відразу",
      "publishImmediatelyHint": "Опублікувати форму відразу",
      "uploadButton": "Завантажити XLSForm",
      "uploading": "Завантаження...",
      "noFileSelected": "Будь ласка, виберіть файл для завантаження",
      "noFormId": "Будь ласка, введіть ID форми",
      "uploadingMessage": "Завантаження XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" успішно завантажений!",
      "errorMessage": "Помилка завантаження: {error}",
      "errorFallback": "Не вдалося завантажити файл. Спробуйте ще раз.",
      "listUpdated": "XLSForm успішно завантажений! Список оновлено."
    },
    "formDetail": {
      "loading": "Завантаження форми...",
      "formLabel": "Форма",
      "returnToProjects": "Повернутися до списку проектів",
      "sectionShell": {
        "unknownForm": "Невідома форма",
        "loading": "Завантаження...",
        "retry": "Спробувати знову",
        "comingSoonTitle": "Близько",
        "comingSoonDescription": "Ця функція знаходиться в розробці. Використовуйте інші інструменти для форм в цей час."
      },
      "sections": {
        "dashboard": {
          "title": "Огляд форми",
          "description": "Статистика та інформація про форму та зібрані дані"
        },
        "qc": {
          "title": "Контроль якості",
          "description": "Моніторинг та валідація якості даних за допомогою правил QC",
          "workbench": {
            "contextHint": "Налаштуйте правила, перевіряйте submissions і розбирайте знайдені проблеми для цієї форми.",
            "rulesCount": "{count} правил",
            "activeCount": "{count} активних",
            "validationsCount": "{count} перевірок",
            "summaryTitle": "Огляд правил",
            "selectedCount": "Обрано: {count}",
            "createRuleHint": "Створити нову правило перевірки для цієї форми",
            "editRuleHint": "Оновити налаштування та вираз правила",
            "backToRules": "Повернутися до правил",
            "pipeline": {
              "ariaLabel": "Процес QC-валідації",
              "define": "Налаштувати правила",
              "defineHint": "Налаштовано правил: {count}",
              "defineEmpty": "Правил ще немає — створіть першу перевірку",
              "validate": "Перевірити дані",
              "validateHint": "Перевірено submissions: {count}",
              "validateEmpty": "Запустіть перевірку вхідних submissions",
              "review": "Розібрати проблеми",
              "reviewHint": "Відкритих проблем: {count}",
              "reviewClear": "Немає невирішених проблем"
            }
          }
        },
        "dataExport": {
          "title": "Експорт даних",
          "description": "Експорт даних форми у різних форматах"
        },
        "odkExport": {
          "title": "Експорт даних",
          "description": "Експорт даних форми у різних форматах для аналізу",
          "unknownForm": "Невідома форма",
          "exportsCount": "{count} експортів",
          "loadingOptions": "Завантаження параметрів експорту...",
          "retry": "Повторити",
          "infoSubtitleDetailed": "Виберіть формати експорту та налаштуйте параметри для завантаження даних вашої форми.",
          "formatsAvailable": "Доступно форматів: {count}",
          "formatsTitle": "Формати експорту",
          "selectFormats": "Виберіть один або кілька форматів для експорту",
          "statisticalFormatsTitle": "Статистичні формати",
          "geoFormatsTitle": "Географічні формати",
          "noGeoData": "У цій формі не знайдено географічних даних",
          "configTitle": "Конфігурація експорту",
          "configSubtitle": "Налаштуйте параметри експорту та фільтри",
          "dataOptions": "Параметри даних",
          "includeRepeats": "Включити повторювані групи",
          "includeLabels": "Включити мітки полів",
          "includeMetadata": "Включити метадані",
          "labelLanguage": "Мова міток",
          "selectLanguage": "Виберіть мову",
          "loadingLanguages": "Завантаження мов...",
          "generatingLabels": "Генерація міток...",
          "noLabelsAvailable": "Мітки недоступні. Натисніть оновити, щоб згенерувати мітки.",
          "filters": "Фільтри",
          "dateRange": "Діапазон дат",
          "startDate": "Дата початку",
          "endDate": "Дата закінчення",
          "dataFilter": "Фільтр даних",
          "dataFilterPlaceholder": "наприклад, age > 18",
          "readyToExport": "Готовий до експорту",
          "readyToExportSubtitle": "Натисніть кнопку, щоб почати процес експорту",
          "labelsRequiredNotice": "Мітки обов'язкові, але недоступні. Будь ласка, спочатку згенеруйте мітки.",
          "activeExports": "Активні експорти",
          "exportButton": "Експортувати дані",
          "historyTitle": "Історія експорту",
          "historySubtitle": "Перегляньте попередні експорти та завантажте їх",
          "refresh": "Оновити",
          "loadingHistory": "Завантаження історії...",
          "noHistory": "Експортів поки немає",
          "noHistoryDesc": "Почніть з експорту даних у зручному для вас форматі.",
          "workbench": {
            "contextHint": "Виберіть формати та параметри, потім запустіть експорт.",
            "geoAvailable": "Географічні дані",
            "geoUnavailable": "Немає географічних даних",
            "optionsTitle": "Параметри",
            "refreshLabels": "Оновити мітки",
            "labelsGenerated": "Мітки згенеровані ({count} мов)",
            "exportButtonOne": "Експортувати 1 формат",
            "exportButtonMany": "Експортувати {count} форматів",
            "selectFormatHint": "Виберіть хоча б один формат для експорту.",
            "readySummaryOne": "1 формат готовий до експорту.",
            "readySummaryMany": "{count} формати готові до експорту.",
            "jobsTitle": "Завдання",
            "jobsSubtitle": "Відстежуйте активні експорти та завантажуйте попередні файли.",
            "noActiveJobs": "Немає активних експортів.",
            "noHistoryAction": "Виберіть формат вище та запустіть експорт.",
            "pipeline": {
              "sync": "Синхронізувати дані",
              "convert": "Конвертувати",
              "ready": "Готово"
            }
          },
          "date": "Дата",
          "format": "Формат",
          "records": "Записи",
          "size": "Розмір",
          "user": "Користувач",
          "actions": "Дії",
          "download": "Завантажити",
          "viewError": "Перегляд помилки",
          "errorDetails": "Деталі помилки",
          "errorSubtitle": "Інформація про помилку експорту",
          "close": "Закрити",
          "deleteTitle": "Видалити експорт",
          "deleteSubtitle": "Цю дію неможливо скасувати",
          "deleteConfirm": "Ви впевнені, що хочете видалити експорт від {date}? Цю дію неможливо скасувати.",
          "cancel": "Скасувати",
          "delete": "Видалити",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Всі дані",
            "last30": "Останні 30 днів",
            "last90": "Останні 90 днів",
            "thisyear": "Цей рік",
            "lastyear": "Минулий рік",
            "custom": "Довільний період"
          },
          "status": {
            "odataSyncError": "Помилка перевірки синхронізації OData: {error}",
            "localDataMissing": "Локальні дані відсутні, завантаження OData...",
            "odataStatusError": "Помилка статусу OData",
            "downloadingOdata": "Завантаження OData...",
            "downloadSuccessCount": "Завантажено {count} записів",
            "downloadError": "Помилка завантаження OData: {error}",
            "geoRequired": "{format} вимагає наявності географічних даних"
          },
          "notifications": {
            "selectFormat": "Будь ласка, виберіть хоча б один формат",
            "startingDownload": "Початок завантаження...",
            "downloadSuccess": "Файл успішно завантажено",
            "downloadError": "Помилка завантаження: {error}",
            "taskIdMissing": "Неможливо завантажити: відсутній ID завдання",
            "exportDeleted": "Експорт успішно видалено",
            "exportCompleted": "Експорт {format} завершено",
            "exportFailed": "Експорт {format} не вдався",
            "trackingError": "Помилка відстеження: {error}",
            "noErrorDetails": "Деталі помилки відсутні",
            "currentUser": "Поточний користувач"
          }
        },
        "dataAnalysis": {
          "title": "Аналіз даних",
          "description": "Створюйте таблиці півок для аналізу та зберігайте вигляди для моніторингу",
          "recordsLoaded": "{count} записів завантажено",
          "variablesSelected": "{count} змінних вибрано",
          "tablesAvailable": "{count} таблиць доступно",
          "workbench": {
            "contextHint": "Виберіть змінні, досліджуйте з таблицею півок, потім збережіть вигляд для моніторингу",
            "loadingData": "Завантаження даних...",
            "pipeline": {
              "ariaLabel": "Робочий процес аналізу",
              "source": "Джерело даних",
              "sourceHint": "{table}",
              "sourceEmpty": "Виберіть таблицю даних",
              "variables": "Змінні",
              "variablesHint": "{count} вибрано",
              "variablesEmpty": "Виберіть поля для аналізу",
              "pivot": "Таблиця півок",
              "pivotHint": "{count} записів завантажено",
              "pivotEmpty": "Завантажте дані для дослідження",
              "pivotLoading": "Завантаження записів...",
              "save": "Зберегти вигляд",
              "saveHint": "Готово до збереження в моніторинг",
              "saveEmpty": "Налаштуйте півок спочатку"
            },
            "source": {
              "title": "Джерело даних",
              "subtitle": "Виберіть яку таблицю відповідей і як значення відображаються",
              "labelsMissing": "Мітки не генеруються для цієї форми",
              "labelsMissingHint": "Створіть мітки з XLSForm, щоб показати назви змінних і мітки значень.",
              "generateLabels": "Створити мітки",
              "table": "Таблиця даних",
              "tablePlaceholder": "Виберіть таблицю даних",
              "displayOptions": "Опції відображення",
              "showLabels": "Показати мітки",
              "language": "Мова",
              "includeMetadata": "Включити метадані"
            },
            "variables": {
              "title": "Змінні",
              "selectedCount": "{count} вибрано",
              "selectTableFirst": "Виберіть таблицю даних, щоб побачити доступні змінні.",
              "selectAll": "Вибрати все",
              "clearAll": "Очистити все",
              "searchPlaceholder": "Пошук змінних...",
              "empty": "Немає змінних, що відповідають вашому пошуку",
              "moreCount": "+{count} більше",
              "loading": "Завантаження...",
              "loadCta": "Завантажити {count} змінних"
            },
            "pivot": {
              "title": "Таблиця півок",
              "subtitle": "Перетягніть поля до рядків, стовпців або значень, щоб створити ваш вигляд",
              "hint": "Перетягніть змінні до рядків, стовпців або значень. Коли макет виглядає правильно, збережіть його як таблицю моніторингу.",
              "reprocess": "Переобробити аналіз",
              "saveCta": "Зберегти в моніторинг",
              "analyticsProcessed": "{percent}% оброблено"
            },
            "empty": {
              "title": "Виберіть змінні",
              "hint": "Виберіть одну або більше змінних з вибраної таблиці, щоб почати ваш аналіз."
            },
            "save": {
              "title": "Зберегти таблицю моніторингу",
              "subtitle": "Дайте цьому вигляду півок назву, щоб ви могли знайти його на сторінці моніторингу.",
              "tableName": "Назва таблиці",
              "tableNamePlaceholder": "Введіть назву таблиці",
              "description": "Опис",
              "descriptionPlaceholder": "Що відстежує ця таблиця?",
              "summary": "Сума аналізу",
              "variables": "Змінні",
              "table": "Таблиця",
              "cancel": "Скасувати",
              "confirm": "Зберегти таблицю"
            },
            "toasts": {
              "labelsGenerated": "Мітки згенеровані. Завантаження змінних...",
              "labelsFailed": "Неможливо згенерувати мітки. Перевірте, чи доступний XLSForm.",
              "saveSuccess": "Таблиця збережена. Відкрийте моніторинг даних, щоб побачити її.",
              "saveFailed": "Неможливо зберегти таблицю. Спробуйте знову або зверніться до підтримки.",
              "formIdMissing": "ID форми не знайдено",
              "reprocessSuccess": "Аналіз переоброблений: {count} нових записів",
              "reprocessFailed": "Помилка переобробки аналізу",
              "reprocessError": "Помилка переобробки аналізу: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Моніторинг даних",
          "description": "Перегляд збережених таблиць моніторингу з реальним часом оновлень",
          "tablesCount": "{count} таблиць",
          "updating": "Оновлення...",
          "workbench": {
            "contextHint": "Збережені вигляди півок з живим оновленням даних, коли ця сторінка відкрита",
            "activeViewsCount": "{count} активних",
            "liveStrip": {
              "ariaLabel": "Статус моніторингу",
              "saved": "Збережені таблиці",
              "savedHint": "{count} таблиць готові",
              "savedEmpty": "Немає збережених таблиць",
              "watch": "Активний вигляд",
              "watchHint": "Перегляд {title}",
              "watchEmpty": "Виберіть таблицю для перегляду",
              "watchDisabled": "Створіть таблицю спочатку",
              "sync": "Жива синхронізація",
              "syncHint": "Оновлення кожні 30 секунд",
              "syncActive": "Оновлення зараз..."
            },
            "displayOptions": {
              "title": "Опції відображення",
              "subtitle": "Контролюйте, як назви змінних відображаються в таблицях півок",
              "showLabels": "Показати мітки",
              "language": "Мова"
            },
            "summary": {
              "title": "На перший погляд",
              "tables": "Збережені таблиці",
              "activeView": "Активний вигляд",
              "records": "Записи в вигляді",
              "refreshInterval": "Автоматичне оновлення"
            },
            "tables": {
              "title": "Таблиці моніторингу",
              "subtitle": "Збережені вигляди півок з аналізу даних",
              "loading": "Завантаження таблиць моніторингу...",
              "emptyTitle": "Немає таблиць моніторингу",
              "emptyHint": "Створіть таблицю півок на сторінці аналізу і збережіть її тут.",
              "createCta": "Перейти до аналізу",
              "realtimeHint": "Дані оновлюються кожні 30 секунд, коли ця сторінка відкрита. Використовуйте Оновлення для миттєвого оновлення.",
              "records": "{count} записів",
              "lastUpdated": "Останнє оновлення {time}",
              "view": "Перегляд",
              "hide": "Приховати",
              "loadingPivot": "Завантаження даних півок...",
              "public": "Публічний",
              "private": "Приватний"
            },
            "delete": {
              "title": "Видалити таблицю",
              "confirm": "Видалити таблицю \"{title}\"?",
              "detail": "Ця дія постійно видаляє таблицю і її кешовані дані.",
              "cancel": "Скасувати",
              "confirmBtn": "Видалити таблицю"
            }
          }
        },
        "settings": {
          "title": "Налаштування",
          "description": "Управління налаштуваннями форми",
          "formStatus": "Статус форми",
          "basicSettings": "Основні налаштування",
          "notifications": {
            "noChanges": "Немає змін для збереження",
            "draftWarning": "Чернетки форм не можна змінити через цей інтерфейс. Спочатку опублікуйте форму.",
            "stateChangeHint": "Зміна статусу форми впливає на прийом нових відправлень.",
            "invalidState": "Недопустимий статус форми: {state}",
            "success": "Статус форми успішно змінено на {state}",
            "error": "Помилка зміни статусу форми: {error}",
            "errorLog": "Помилка зміни статусу форми"
          },
          "version": {
            "title": "Версія",
            "notSpecified": "Не вказана",
            "history": "Історія версій",
            "noHistory": "Історія версій відсутня",
            "download": "Завантажити",
            "restore": "Відновити",
            "uploadNew": "Завантажити нову версію",
            "author": "Автор"
          },
          "dataCollectors": {
            "title": "Збирачі даних",
            "description": "Управління доступом користувачів до збору даних по формі",
            "noCollectors": "Немає призначених збирачів даних",
            "addCollector": "Додати збирача",
            "editCollector": "Редагувати збирача",
            "removeCollector": "Видалити збирача",
            "addCollectorModal": {
              "title": "Додати збирача даних",
              "placeholder": "Заглушка: тут буде форма додавання збирача даних"
            }
          },
          "publicAccess": {
            "title": "Публічний доступ",
            "description": "Створіть публічне посилання для збору даних через веб-інтерфейс",
            "publicLink": "Публічне посилання",
            "disable": "Відключити",
            "requireAuth": "Вимагати аутентифікації",
            "collectEmail": "Збирати електронну пошту",
            "limitSubmissions": "Обмежити кількість відповідей",
            "maxSubmissions": "Максимальна кількість відповідей",
            "updateSettings": "Оновити налаштування",
            "createLink": "Створити публічне посилання",
            "notCreated": "Публічне посилання не створено. Створіть посилання для збору даних через веб-інтерфейс.",
            "created": "Публічне посилання створено",
            "copied": "Посилання скопіровано в буфер обміну",
            "disabled": "Публічне посилання відключено",
            "updated": "Налаштування публічного посилання оновлено"
          },
          "qrCodes": {
            "title": "QR-коди для збору даних",
            "description": "Керування QR-кодами для налаштування пристроїв збору даних для цієї форми",
            "assignedTitle": "Призначені QR-коди",
            "availableTitle": "Доступні QR-коди проєкту",
            "createNew": "Створити новий QR-код",
            "noAvailable": "Немає доступних QR-кодів",
            "createInstruction": "Створіть QR-код для налаштування пристроїв збору даних",
            "manageOnProject": "QR-коди ODK Collect керуються на рівні проєкту (App Users).",
            "openProjectQr": "Відкрити QR-коди проєкту",
            "openFormAccess": "Керувати доступом до форм",
            "notifications": {
              "assigned": "QR-код призначено формі",
              "unassigned": "QR-код відв'язано від форми",
              "copied": "Base64 скопійовано в буфер обміну",
              "copyError": "Помилка копіювання: {error}"
            }
          },
          "attachments": {
            "title": "Вкладення та медіафайли",
            "description": "Управління файлами та вкладеннями, пов'язаними з формою",
            "xlsformFile": "XLSForm файл",
            "xlsformDescription": "Завантажте оригінальний XLSForm файл цієї форми в форматі Excel",
            "downloadXlsform": "Завантажити XLSForm",
            "manageAttachments": "Управління вкладеннями",
            "downloadSuccess": "XLSForm файл успішно завантажено",
            "downloadError": "Помилка при завантаженні XLSForm файлу",
            "fileNotFound": "XLSForm файл не знайдено для цієї форми",
            "accessDenied": "Немає доступу до завантаження XLSForm файлу",
            "serverError": "Помилка сервера: {status}"
          },
          "analytics": {
            "title": "Керування аналітикою",
            "recreateAnalytics": "Примусово перестворити аналітику",
            "description": "Перестворити дані аналітики для всіх надсилань форми. Використовуйте, коли дані пошкоджені або відсутні.",
            "warning": "Ця операція видалить усю наявну аналітику та перестворить її з сирих даних надсилань.",
            "confirmTitle": "Підтвердити перестворення аналітики",
            "alertTitle": "Увага: потрібне перестворення даних",
            "alertDescription": "Ця дія остаточно видалить усі наявні дані аналітики та перестворить їх з нуля.",
            "whatWillHappen": "Що станеться:",
            "step1": "Усі наявні дані аналітики будуть видалені",
            "step2": "Сирі дані надсилань будуть оброблені знову",
            "step3": "Нові дані аналітики будуть створені з правильною формацією",
            "step4": "Зведені таблиці та функції аналізу працюватимуть коректно",
            "timeWarning": "Операція може тривати кілька хвилин для форм із великою кількістю надсилань.",
            "recreateButton": "Примусово перестворити аналітику",
            "confirmButton": "Так, перестворити аналітику",
            "success": "Аналітику перестворено успішно! Оброблено {processed} надсилань, перестворено {recreated} записів аналітики з {total} надсилань загалом.",
            "error": "Не вдалося перестворити дані аналітики",
            "apiError": "Помилка API: {error}"
          },
          "dangerZone": {
            "title": "Небезпечна зона",
            "deleteForm": "Видалення форми",
            "description": "Цю дію неможливо скасувати. Всі зібрані дані будуть втрачені.",
            "confirmDelete": "Підтвердження видалення форми",
            "confirmMessage": "Ви дійсно хочете видалити форму \"{name}\"?",
            "confirmDescription": "Цю дію неможливо скасувати. Всі зібрані дані будуть втрачені.",
            "enterFormName": "Введіть назву форми для підтвердження",
            "deleteFormButton": "Видалити форму",
            "formDeleted": "Форма видалена (функція-заглушка)"
          }
        },
        "datasets": {
          "title": "Набори даних",
          "description": "Управління наборами даних та сутностями"
        }
      },
      "errors": {
        "missingParams": "Відсутні необхідні параметри для завантаження форми",
        "loadError": "Помилка завантаження даних форми",
        "unknownError": "Невідома помилка"
      }
    },
    "dashboard": {
      "loading": "Завантаження аналітики...",
      "analyticsError": "Помилка при завантаженні аналітики",
      "retry": "Повторити завантаження",
      "workbench": {
        "contextHint": "Ідентичність форми, надходження, часова шкала та AI для одного спільного періоду (7 / 30 / all).",
        "completionBadge": "Заповнення {rate}%",
        "metaVersion": "v{version}",
        "metaPublished": "опубл. {date}",
        "metaUpdated": "онов. {date}",
        "summaryTitle": "Зведення збору",
        "sections": {
          "metadata": {
            "title": "Ідентифікатор форми",
            "xmlFormId": "ID XML-форми",
            "version": "Версія",
            "published": "Опублікована",
            "updated": "Останнє оновлення"
          },
          "intake": {
            "title": "Зведення збору",
            "subtitle": "Надходження відповідей за сьогодні, тиждень і за весь час"
          },
          "quickLinks": {
            "title": "Швидкі посилання"
          },
          "agent": {
            "title": "AI-асистент",
            "subtitle": "Зведення, аналітичні звіти та чат щодо цієї форми"
          },
          "timeline": {
            "title": "Динаміка відповідей",
            "subtitle": "Кількість відповідей по днях за обраний період"
          },
          "map": {
            "title": "Географічний розподіл",
            "subtitle": "Точки збору з геоданими"
          }
        },
        "metrics": {
          "noChange": "Без змін"
        },
        "intakeStrip": {
          "ariaLabel": "Статус надходження даних",
          "today": "Сьогодні",
          "todayDelta": "{delta} до вчора",
          "todayFlat": "Як учора",
          "week": "За тиждень",
          "weekDelta": "{delta} до минулого тижня",
          "weekFlat": "Як на минулому тижні",
          "total": "Усього відповідей",
          "totalHint": "Усього зібрано по цій формі",
          "totalEmpty": "Відповідей поки немає"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Всього відповідей",
          "today": "сьогодні"
        },
        "completedSubmissions": {
          "title": "Завершені відповіді",
          "rate": "відсоток завершення"
        },
        "dataCollectors": {
          "title": "Збирачі даних",
          "new": "нових"
        },
        "problematicSubmissions": {
          "title": "Проблемні відповіді"
        },
        "submissionTimeline": {
          "title": "Часові рамки відправлень",
          "totalForPeriod": "Всього за період",
          "noData": "Немає даних про часові рамки відправлень",
          "noSubmissionsInPeriod": "Немає відправлень за вибраний період",
          "stats": {
            "totalSubmissions": "Всього відправлень",
            "maxPerDay": "Максимум за день",
            "trend": "Тенденція"
          },
          "timeframes": {
            "7days": "За 7 днів",
            "30days": "За 30 днів",
            "90days": "За 90 днів"
          },
          "trend": {
            "stable": "Без змін",
            "growth": "Зростання",
            "decline": "Спад"
          },
          "hint": "Натисніть на стовпець, щоб побачити детальну інформацію за день"
        }
      }
    },
    "summaryCard": {
      "id": "ID",
      "statusNotSet": "Статус не встановлено",
      "statusDescriptions": {
        "published": "Форма відкрита для збору даних",
        "closing": "Форма закривається, нові відповіді обмежені",
        "closed": "Форма закрита, нові відповіді не приймаються",
        "draft": "Форма в режимі чернетки, не опублікована",
        "unknown": "Статус не розпізнано"
      },
      "stats": {
        "today": "За сьогодні",
        "week": "За тиждень",
        "total": "Всього зібрано",
        "responses": "відповідей на форму",
        "fromYesterday": "від вчора",
        "fromLastWeek": "від минулого тижня"
      },
      "info": {
        "version": "Версія",
        "notSpecified": "Не вказано",
        "created": "Створено",
        "updated": "Оновлено",
        "notUpdated": "Не оновлювалася",
        "published": "Опубліковано",
        "notPublished": "Не опубліковано",
        "notSpecifiedDate": "Не вказано"
      },
      "trend": {
        "title": "Тенденція заповнення за останні 7 днів",
        "noData": "Немає даних",
        "growth": "Зростання",
        "decline": "Спад",
        "stable": "Без змін"
      }
    },
    "attachments": {
      "title": "Вкладення форми",
      "formLabel": "Форма:",
      "noAttachmentsRequired": "Вкладення не потрібні",
      "noAttachmentsDescription": "Ця форма не містить посилань на зовнішні файли (зображення, документи тощо).",
      "noAttachmentsHint": "Якщо ви додасте посилання на файли в XLSForm, вони автоматично з'являться тут.",
      "uploadSection": {
        "supportedFormats": "Підтримувані формати:",
        "dropZoneTitles": {
          "uploadMissing": "Завантажте відсутні файли",
          "updateExisting": "Оновіть існуючі файли",
          "uploadFiles": "Завантажте файли"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Очікується {count} файл(ів): {files}",
          "updateExisting": "Всі файли завантажені. Ви можете замінити їх новими версіями.",
          "uploadFiles": "Виберіть файли для завантаження вкладень форми."
        },
        "dropZoneButtons": {
          "selectFiles": "Вибрати файли",
          "updateFiles": "Оновити файли",
          "chooseFiles": "Вибрати файли"
        },
        "selectedFiles": "Вибрані файли ({count})",
        "uploadButton": "Завантажити {count} файлів",
        "uploading": "Завантажуємо...",
        "clear": "Очистити",
        "chooseFiles": "Вибрати файли"
      },
      "table": {
        "columns": {
          "name": "Ім'я файлу",
          "status": "Статус",
          "type": "Тип",
          "size": "Розмір",
          "updatedAt": "Дата завантаження",
          "actions": "Дії"
        },
        "status": {
          "uploaded": "Завантажено",
          "missing": "Відсутній",
          "deleted": "Видалено",
          "unknown": "Невідомо"
        },
        "actions": {
          "download": "Завантажити",
          "delete": "Видалити",
          "deleted": "Видалено",
          "missing": "Відсутній"
        },
        "notSpecified": "Не вказано"
      },
      "messages": {
        "uploadSuccess": "Успішно завантажено {count} файлів",
        "uploadError": "Помилка завантаження файлів: {error}",
        "fileNotFound": "Файл {filename} не знайдено в вибраних файлах",
        "fileUploadSuccess": "Файл {filename} успішно завантажено",
        "fileUploadError": "Помилка завантаження файлу {filename}: {error}",
        "downloadError": "Помилка завантаження файлу {filename}: {error}",
        "deleteSuccess": "Файл {filename} успішно видалено",
        "deleteError": "Помилка видалення файлу {filename}: {error}",
        "invalidFilesIgnored": "Наступні файли будуть проігноровані (не знайдені в списку очікуваних): {files}",
        "filesWillBeUpdated": "Наступні файли будуть оновлені: {files}",
        "loadingError": "Помилка завантаження вкладень",
        "downloadSuccess": "Файл {filename} успішно завантажено",
        "fileAlreadyDeleted": "Файл {filename} вже був видалений або не існує",
        "fileNotInExpectedList": "Файл не знайдено в списку очікуваних вкладень"
      },
      "confirmDelete": {
        "title": "Підтвердження видалення",
        "message": "Ви впевнені, що хочете видалити файл \"{filename}\"?",
        "warning": "Цю дію неможливо скасувати.",
        "deleting": "Видаляємо...",
        "delete": "Видалити"
      }
    }
  },
  "pageNotFound": {
    "title": "Ой! Сторінку не знайдено.",
    "subtitle": "404",
    "description": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
    "goBack": "Назад",
    "goHome": "На головну",
    "copyright": "© {year} UDACAPI. Всі права захищені."
  },
  "maps": {
    "tabTitle": "Карта",
    "pageTitle": "Карта проекту",
    "subtitle": "Відстежуйте збір даних із GPS-координатами в реальному часі",
    "empty": {
      "noGeoForms": "У цьому проекті поки немає форм із GPS-питаннями.",
      "noPoints": "Немає подань, що відповідають поточним фільтрам."
    },
    "filters": {
      "title": "Фільтри",
      "forms": "Форми",
      "dateFrom": "З",
      "dateTo": "По",
      "qcStatus": "Статус QC",
      "enumerator": "Енумератор",
      "heatmap": "Теплова карта",
      "reset": "Скинути фільтри",
      "apply": "Застосувати"
    },
    "qcStatuses": {
      "any": "Будь-який",
      "pass": "Пройдено",
      "fail": "Провалено",
      "warning": "Попередження",
      "error": "Помилка",
      "none": "Не перевірено"
    },
    "actions": {
      "export": "Експорт у GeoJSON",
      "refresh": "Оновити",
      "settings": "Налаштування карти",
      "openSubmission": "Відкрити подання",
      "openFormOnMap": "Переглянути форму на карті"
    },
    "popup": {
      "submittedAt": "Подано",
      "submittedBy": "Автор подання",
      "form": "Форма",
      "status": "Статус QC"
    },
    "truncated": "Показано перші {limit} точок. Уточніть фільтри або ввімкніть кластеризацію, щоб побачити більше.",
    "settingsDialog": {
      "title": "Налаштування карти проекту",
      "defaultCenter": "Центр за замовчуванням",
      "defaultCenterHint": "Клацніть на карті, щоб обрати точку",
      "defaultZoom": "Масштаб за замовчуванням",
      "defaultForms": "Форми за замовчуванням",
      "heatmapDefault": "Вмикати теплову карту за замовчуванням",
      "coordinateFields": "Поля координат",
      "latitudeField": "Поле широти",
      "longitudeField": "Поле довготи",
      "automaticDetection": "Використати авто-визначення",
      "coordinateSourceTitle": "Джерело координат",
      "coordinateMode": "Режим координат",
      "modeAuto": "Автовизначення",
      "modeNone": "Немає геоданих",
      "modeLatLon": "Поля широти та довготи",
      "modeGeopoint": "Поле geopoint",
      "geopointField": "Поле geopoint",
      "detectedSource": "Автовизначене джерело: {path} · точок зараз: {count}",
      "configureCoordinates": "Поля координат",
      "noMapHint": "Немає точок на карті для цієї форми. Налаштуйте координатні поля, якщо подання містять локації.",
      "save": "Зберегти",
      "cancel": "Скасувати",
      "saved": "Налаштування збережено"
    },
    "savedViews": {
      "title": "Збережені вигляди",
      "noViewsYet": "Немає збережених виглядів — створіть на карті проєкту",
      "recommended": "Рекомендований",
      "defaultLabel": "за замовчуванням",
      "saveHint": "Після Apply карта застосовує фільтри та теплову карту. «Зберегти поточний вигляд» зберігає цю конфігурацію під назвою (лише для менеджерів проєкту).",
      "saveCurrent": "Зберегти поточний вигляд",
      "updateCurrent": "Оновити вигляд",
      "delete": "Видалити вигляд",
      "name": "Назва вигляду",
      "pinAsDefault": "Встановити за замовчуванням",
      "pin": "Закріпити вигляд",
      "saved": "Вигляд збережено",
      "updated": "Вигляд оновлено",
      "deleted": "Вигляд видалено",
      "saveFailed": "Неможливо зберегти вигляд. Перевірте, чи розгорнуто API і чи міграції бази даних містять project_map_views.",
      "updateFailed": "Неможливо оновити вигляд.",
      "deleteFailed": "Неможливо видалити вигляд."
    },
    "tileConfig": {
      "sectionTitle": "Сервер тайлів карти",
      "sectionDescription": "Вкажіть власний URL-шаблон тайл-сервера для організації. Залиште порожнім, щоб використовувати публічні тайли OpenStreetMap.",
      "url": "URL-шаблон тайлів",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Атрибуція",
      "subdomains": "Піддомени",
      "maxZoom": "Макс. масштаб",
      "minZoom": "Мін. масштаб",
      "test": "Перевірити URL",
      "configure": "Налаштувати",
      "edit": "Редагувати",
      "defaultTiles": "Використовуються публічні тайли OpenStreetMap",
      "zoom": "Масштаб",
      "clear": "Очистити",
      "save": "Зберегти",
      "saved": "Конфігурацію тайлів збережено",
      "cleared": "Власний сервер тайлів очищено"
    }
  },
  "help": {
    "title": "Довідка",
    "subtitle": "Короткі посібники та відповіді на типові завдання в UDACAPI.",
    "searchPlaceholder": "Шукати посібники та запитання…",
    "learnMore": "Докладніше",
    "openGuide": "Відкрити",
    "openGuideFormScope": "Відкрити панель — потім оберіть проєкт і форму",
    "whenToUse": "Коли використовувати",
    "steps": "Кроки",
    "comingSoon": "Незабаром з'являться додаткові посібники з аналізу, моніторингу та налаштувань організації.",
    "noResults": "Жоден посібник не відповідає вашому пошуку.",
    "featureGuides": {
      "odkServers": {
        "title": "Сервери ODK",
        "summary": "Підключіть сервер ODK Central (або сумісний), щоб UDACAPI міг синхронізувати проєкти та надходження.",
        "whenToUse": "Початкове налаштування, перед синхронізацією або імпортом.",
        "steps": [
          "Відкрийте Сервери ODK на бічній панелі.",
          "Додайте URL сервера та облікові дані.",
          "Запустіть Перевірити з'єднання.",
          "Виправте URL, облікові дані або мережеві проблеми перед синхронізацією."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Отримуйте нові надходження та оновлюйте структуру форми з ODK.",
        "whenToUse": "Після підключення сервера; коли очікуєте нові польові дані.",
        "steps": [
          "Відкрийте Sync Workbench.",
          "Оберіть сервер, проєкт і форму.",
          "Перегляньте курсор і стан останньої синхронізації.",
          "Запустіть синхронізацію та дочекайтеся завершення.",
          "Відкрийте форму — Overview, Export або QC."
        ]
      },
      "import": {
        "title": "Імпорт проєктів і форм",
        "summary": "Перенесіть наявні проєкти та форми ODK до вашої організації.",
        "whenToUse": "Міграція з ODK або підключення нового сервера.",
        "steps": [
          "Переконайтеся, що сервер ODK підключено та перевірено.",
          "У Проєктах запустіть Імпорт (лише сервери організації).",
          "Оберіть проєкт і імпортуйте форми.",
          "Відкрийте форму та перевірте Overview і Settings."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "AI workbench для чернеток, попереднього перегляду та публікації змін XLSForm.",
        "whenToUse": "Нові опитування або суттєві зміни схеми.",
        "steps": [
          "Відкрийте проєкт і запустіть XLSForm Assist.",
          "Опишіть опитування або завантажте файл із запитаннями.",
          "Перегляньте попередній перегляд ODK Web Forms.",
          "Підтвердіть публікацію та дочекайтеся завершення завдання."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Знімок надходжень, часової шкали, карти та AI Q&A для обраного періоду.",
        "whenToUse": "Щоденний моніторинг; швидкі запитання про дані форми в реальному часі.",
        "steps": [
          "Відкрийте форму та перейдіть до Overview.",
          "Оберіть період (7 / 30 / all) — спільний для AI-звітів і часової шкали.",
          "Перегляньте часову шкалу та карту.",
          "Скористайтеся AI-чатом або згенеруйте зведені звіти для того ж вікна."
        ]
      },
      "autoReports": {
        "title": "Автозвіти",
        "summary": "Заплановані та за запитом AI-звіти для кожної форми з доставкою email.",
        "whenToUse": "Регулярні оновлення для зацікавлених сторін (щотижня або щомісяця).",
        "steps": [
          "Org → Шаблони звітів — створіть або оберіть шаблон.",
          "Форма → Автозвіти — налаштуйте розклад і одержувачів.",
          "Використайте Generate для ручного попереднього перегляду з періодом.",
          "Використайте Send для доставки після попереднього перегляду."
        ]
      },
      "qc": {
        "title": "Контроль якості (QC)",
        "summary": "Правила валідації надходжень; AI може запропонувати стартовий набір.",
        "whenToUse": "Після перших надходжень; перед тим як довіряти експорту чи аналізу.",
        "steps": [
          "Відкрийте форму та перейдіть до QC.",
          "Створіть правило або скористайтеся AI suggest.",
          "Запустіть валідацію.",
          "Перегляньте позначені надходження."
        ]
      },
      "export": {
        "title": "Експорт даних",
        "summary": "Експортуйте надходження в CSV, Excel тощо; великі форми використовують асинхронні завдання.",
        "whenToUse": "Передача в Excel, SPSS, Stata або зовнішні pipeline.",
        "steps": [
          "Відкрийте форму та перейдіть до Data Export.",
          "Оберіть формат і параметри.",
          "Запустіть експорт і дочекайтеся завдання.",
          "Завантажте файл зі списку завдань."
        ]
      }
    },
    "faq": {
      "title": "Поширені запитання",
      "items": {
        "sync-no-new-data": {
          "question": "Чому синхронізація не отримує нові надходження?",
          "answer": "Перевірте, чи доступний сервер ODK, чи не застряг курсор синхронізації на старій позиції, чи обрано правильну форму та чи має ваш обліковий запис доступ до цього проєкту. Запустіть Перевірити з'єднання на сервері, потім повторіть синхронізацію з Sync Workbench."
        },
        "sync-cursor": {
          "question": "Що таке курсор синхронізації?",
          "answer": "Курсор — це покажчик інкрементальної синхронізації: де UDACAPI востаннє припинив читання надходжень. Скидання або зміщення курсорів може пропустити або повторно завантажити дані; використайте Sync Workbench, щоб перевірити стан курсора перед повною повторною синхронізацією."
        },
        "import-server-type": {
          "question": "Чому я не можу імпортувати з цього сервера?",
          "answer": "Імпорт проєктів дозволено лише на серверах ODK, що належать організації. Сервери Shared і Global не можна використовувати для імпорту — підключіть org-сервер або зверніться до адміністратора."
        },
        "import-how": {
          "question": "Як імпортувати наявний проєкт ODK?",
          "answer": "Підключіть і перевірте сервер, потім перейдіть до Проєкти → Імпорт, оберіть проєкт і імпортуйте форми. Див. посібник Імпорт проєктів і форм вище для покрокових інструкцій."
        },
        "xlsform-where": {
          "question": "Де знаходиться XLSForm Assist?",
          "answer": "Відкрийте проєкт з Проєктів, потім запустіть XLSForm Assist з області форм проєкту (або з окремого маршруту assist для цього проєкту)."
        },
        "ai-scope": {
          "question": "На що може відповідати AI форми?",
          "answer": "На запитання про схему форми, надходження, аналітику, правила QC і стан синхронізації — на основі даних цієї форми в реальному часі. Він не замінює підтвердження QC або юридичну перевірку персональних даних."
        },
        "ai-quota": {
          "question": "Чому я бачу перевищення квоти?",
          "answer": "Ваша організація досягла ліміту використання агента. Дочекайтеся вікна скидання або зверніться до власника чи адміністратора організації для коригування лімітів."
        },
        "auto-generate-vs-schedule": {
          "question": "У чому різниця між Generate і запланованим звітом?",
          "answer": "Generate запускається за запитом для періоду, який ви обираєте на формі. Заплановані запуски дотримуються cron шаблону та використовують вікно даних, узгоджене з розкладом — не обов'язково те саме, що селектор періоду Overview."
        },
        "auto-templates": {
          "question": "Де керують шаблонами звітів?",
          "answer": "На рівні організації: Моя організація → Шаблони звітів (або швидке посилання на шаблони). Шаблони централізовані в org; вкладка Автозвіти кожної форми показує шаблони, що охоплюють цю форму."
        },
        "qc-first-rule": {
          "question": "Як створити перше правило QC?",
          "answer": "Відкрийте форму → QC → Створити правило або скористайтеся AI suggest для чернетки стартового набору зі структури форми, потім запустіть валідацію."
        },
        "export-slow": {
          "question": "Експорт триває довго — це нормально?",
          "answer": "Так, для великих форм. Експорт виконується як фонові завдання. Тримайте сторінку відкритою або поверніться до Data Export, щоб завантажити після завершення завдання."
        },
        "export-where": {
          "question": "Де мій експортований файл?",
          "answer": "На вкладці Data Export форми — у списку завдань/історії з дією завантаження, коли статус завдання complete."
        },
        "permissions-missing": {
          "question": "Я не бачу проєкт або вкладку",
          "answer": "Ваша група дозволів може не включати цей проєкт або функцію. Попросіть власника організації переглянути групи дозволів і доступ до проєктів."
        }
      }
    },
    "support": {
      "title": "Потрібна додаткова допомога?",
      "body": "Зверніться до підтримки UDACAPI, якщо ці посібники не вирішили вашу проблему.",
      "contactLabel": "Написати на підтримку"
    }
  }
}
